const id = {
  'common.loading': 'Memuat…',
  'common.save': 'Simpan',
  'common.cancel': 'Batal',
  'common.delete': 'Hapus',
  'common.search': 'Cari',
  'common.accessDenied': 'Akses ditolak',
  'common.backToLogin': 'Kembali ke login',
  'common.markAsRead': 'Tandai sudah dibaca',
  'shell.supportDesk': 'Pusat Dukungan',
  'shell.searchPlaceholder': 'Cari tiket, kontak, artikel…',
  'shell.newTicket': 'Tiket baru',
  'shell.notifications': 'Notifikasi',
  'shell.notificationPreferences': 'Preferensi notifikasi',
  'shell.settings': 'Pengaturan',
  'shell.signOut': 'Keluar',
  'shell.expandNavigation': 'Perluas navigasi',
  'shell.collapseNavigation': 'Ciutkan navigasi',
  'shell.caughtUp': 'Semua sudah ditinjau',
  'shell.viewAllNotifications': 'Lihat semua notifikasi',
  'nav.dashboard': 'Dasbor',
  'nav.tickets': 'Tiket',
  'nav.contacts': 'Kontak',
  'nav.companies': 'Perusahaan',
  'nav.reports': 'Laporan',
  'nav.settings': 'Pengaturan',
  'nav.agents': 'Agen',
  'nav.groups': 'Grup',
  'nav.roles': 'Peran',
  'nav.tags': 'Tag',
  'nav.ticketFields': 'Kolom tiket',
  'nav.ticketForms': 'Formulir tiket',
  'nav.businessHours': 'Jam kerja',
  'nav.slaPolicies': 'Kebijakan SLA',
  'nav.automations': 'Otomatisasi',
  'nav.email': 'Email',
  'nav.notificationTemplates': 'Templat notifikasi',
  'nav.apiKeys': 'Kunci API',
  'nav.cannedResponses': 'Respons tersimpan',
  'nav.knowledgeBase': 'Basis pengetahuan',
  'auth.signInTitle': 'Pusat Dukungan SDPL',
  'auth.signInSubtitle': 'Masuk ke akun Anda',
  'auth.emailAddress': 'Alamat email',
  'auth.password': 'Kata sandi',
  'auth.signingIn': 'Sedang masuk…',
  'auth.signIn': 'Masuk',
  'auth.forgotPassword': 'Lupa kata sandi?',
  'auth.twoFactor': 'Autentikasi dua faktor',
  'auth.verificationCode': 'Kode verifikasi',
  'auth.verify': 'Verifikasi',
  'auth.backToLogin': 'Kembali ke login',
  'agents.title': 'Agen',
  'agents.new': 'Agen baru',
  'agents.supportAgents': 'Agen dukungan',
  'agents.collaborators': 'Kolaborator',
  'agents.deactivated': 'Dinonaktifkan',
  'agents.searchPlaceholder': 'Cari berdasarkan nama atau email',
  'agents.edit': 'Ubah',
  'agents.deactivate': 'Nonaktifkan',
  'agents.reactivate': 'Aktifkan kembali',
  'agents.saved': 'Agen disimpan.',
  'agents.firstName': 'Nama depan',
  'agents.lastName': 'Nama belakang',
  'agents.email': 'Email',
  'agents.phone': 'Telepon',
  'agents.timezone': 'Zona waktu',
  'agents.selectTimezone': 'Pilih zona waktu',
  'agents.language': 'Bahasa',
  'agents.selectLanguage': 'Pilih bahasa',
  'agents.emailSignature': 'Tanda tangan email',
  'agents.roleRequired': 'Peran',
  'agents.selectRole': 'Pilih peran',
  'agents.status': 'Status',
  'agents.groupsTitle': 'Grup',
  'agents.manageGroups': 'Kelola grup',
  'agents.notInGroup': 'Belum ada di grup',
  'dashboard.title': 'Dasbor',
  'dashboard.description': 'Beban kerja dukungan dan kesehatan layanan saat ini.',
  'dashboard.allGroups': 'Semua grup yang dapat diakses',
  'dashboard.unresolved': 'Belum terselesaikan',
  'dashboard.overdue': 'Terlambat',
  'dashboard.dueToday': 'Jatuh tempo hari ini',
  'dashboard.open': 'Terbuka',
  'dashboard.onHold': 'Ditahan',
  'dashboard.unassigned': 'Belum ditugaskan',
  'dashboard.trends': 'Tren hari ini',
  'notifications.title': 'Notifikasi',
  'notifications.description': 'Riwayat notifikasi lengkap Anda.',
  'notifications.markAllRead': 'Tandai semua sudah dibaca',
  'notifications.filter': 'Filter',
  'notifications.allTypes': 'Semua jenis',
  'notifications.none': 'Belum ada notifikasi',
  'notifications.assigned': 'Ditugaskan',
  'notifications.reply': 'Balasan',
  'notifications.note': 'Catatan',
  'notifications.slaWarning': 'Peringatan SLA',
  'notifications.slaBreach': 'Pelanggaran SLA',
  'notifications.slaEscalation': 'Eskalasi SLA',
  'notifications.mention': 'Sebutan',
  'preferences.title': 'Preferensi notifikasi',
  'preferences.description': 'Notifikasi dalam aplikasi selalu aktif. Pilih notifikasi yang juga mengirim email.',
  'preferences.emailDigest': 'Ringkasan email',
  'preferences.dailySummary': 'Dapatkan satu email ringkasan harian, bukan email untuk setiap peristiwa.',
  'preferences.digestOff': 'Nonaktif — email untuk setiap peristiwa',
  'preferences.digestDaily': 'Ringkasan harian',
  'preferences.emailNotifications': 'Notifikasi email',
  'activities.button': 'Aktivitas terbaru',
  'activities.title': 'Aktivitas terbaru',
  'activities.loadError': 'Tidak dapat memuat aktivitas terbaru.',
  'activities.systemActor': 'Sistem',
  'activities.noneTitle': 'Belum ada aktivitas terbaru',
  'activities.noneDescription': 'Pembaruan tiket dari Anda dan grup Anda akan muncul di sini saat terjadi.',
  'tickets.title': 'Tiket',
  'tickets.description': 'Semua tiket yang dapat Anda akses, difilter dan diurutkan sesuai kebutuhan Anda.',
  'tickets.dueDateTabs': 'Tanggal jatuh tempo tiket',
  'tickets.tabAll': 'Semua tiket',
  'tickets.tabDueToday': 'Jatuh tempo hari ini',
  'tickets.tabOverdue': 'Terlambat',
  'tickets.tabDueTomorrow': 'Jatuh tempo besok',
  'tickets.searchPlaceholder': 'Cari tiket…',
  'tickets.searchAria': 'Cari tiket',
  'tickets.filters': 'Filter',
  'tickets.filtersWithCount': 'Filter ({count})',
  'tickets.sortAria': 'Urutkan tiket berdasarkan',
  'tickets.sortTrigger': 'Urutkan: {label}',
  'tickets.sortDateCreated': 'Tanggal dibuat',
  'tickets.sortDateUpdated': 'Tanggal diperbarui',
  'tickets.sortPriority': 'Prioritas',
  'tickets.sortStatus': 'Status',
  'tickets.sortDueDate': 'Tanggal jatuh tempo',
  'tickets.sortAscending': 'Urutkan naik',
  'tickets.sortDescending': 'Urutkan turun',
  'tickets.ascending': 'Naik',
  'tickets.descending': 'Turun',
  'tickets.layoutAria': 'Tata letak baris',
  'tickets.layoutTrigger': 'Tata letak: {label}',
  'tickets.layoutCard': 'Kartu',
  'tickets.layoutInbox': 'Kotak masuk',
  'tickets.layoutTable': 'Tabel',
  'tickets.export': 'Ekspor',
  'tickets.exportSelected': 'Ekspor yang dipilih',
  'tickets.selectedCount': '{count} dipilih',
  'tickets.assignAgent': 'Tugaskan agen',
  'tickets.closeAll': 'Tutup semua',
  'tickets.clearSelection': 'Hapus pilihan',
  'tickets.selectAgentPlaceholder': 'Pilih agen...',
  'tickets.assignTo': 'Tugaskan ke',
  'tickets.assign': 'Tugaskan',
  'tickets.loadFailed': 'Gagal memuat tiket. Silakan coba lagi.',
  'tickets.bulkCloseFailed': 'Gagal menutup tiket yang dipilih. Silakan coba lagi.',
  'tickets.bulkAssignFailed': 'Gagal menugaskan tiket yang dipilih. Silakan coba lagi.',
  'tickets.noFilterMatchTitle': 'Tidak ada tiket yang sesuai dengan filter ini',
  'tickets.noFilterMatchDescription': 'Coba hapus filter, perluas rentang tanggal, atau cari istilah lain.',
  'tickets.clearFilters': 'Hapus filter',
  'tickets.queueClearTitle': 'Antrean ini sudah bersih',
  'tickets.queueClearDescription': 'Tiket baru akan muncul di sini saat pelanggan mengirim email, menggunakan portal, atau agen membuatnya.',
  'tickets.newTicket': 'Tiket baru',
  'tickets.selectAllAria': 'Pilih semua tiket',
  'tickets.selectTicketAria': 'Pilih tiket #{number}',
  'tickets.columnContact': 'Kontak',
  'tickets.columnSubject': 'Subjek',
  'tickets.columnState': 'Status',
  'tickets.columnGroup': 'Grup',
  'tickets.columnAgent': 'Agen',
  'tickets.columnPriority': 'Prioritas',
  'tickets.noGroup': 'Tidak ada grup',
  'tickets.unassigned': 'Belum ditugaskan',
  'tickets.createdRelative': 'Dibuat {when}',
  'tickets.unassignedOnly': 'Hanya yang belum ditugaskan',
  'tickets.unknownRequester': 'Pemohon tidak dikenal',
  'tickets.overdueBy': 'Terlambat {duration}',
  'tickets.dueIn': 'Jatuh tempo dalam {duration}',
  'tickets.filtersDrawerTitle': 'Filter',
  'tickets.filtersSearchPlaceholder': 'Cari kolom',
  'tickets.filtersSearchAria': 'Cari kolom filter',
  'tickets.filtersClearAll': 'Hapus semua',
  'tickets.filtersApply': 'Terapkan',
  'tickets.filterAgents': 'Agen',
  'tickets.filterAnyAgent': 'Agen apa pun',
  'tickets.filterGroups': 'Grup',
  'tickets.filterAnyGroup': 'Grup apa pun',
  'tickets.filterStatus': 'Status',
  'tickets.filterAnyStatus': 'Status apa pun',
  'tickets.filterPriority': 'Prioritas',
  'tickets.filterAnyPriority': 'Prioritas apa pun',
  'tickets.filterSource': 'Sumber',
  'tickets.filterAnySource': 'Sumber apa pun',
  'tickets.filterTicketType': 'Jenis tiket',
  'tickets.filterAnyType': 'Jenis apa pun',
  'tickets.filterTags': 'Tag',
  'tickets.filterAnyTag': 'Tag apa pun',
  'tickets.filterCompanies': 'Perusahaan',
  'tickets.filterAnyCompany': 'Perusahaan apa pun',
  'tickets.filterCreated': 'Dibuat',
  'tickets.filterResolvedAt': 'Diselesaikan pada',
  'tickets.filterClosedAt': 'Ditutup pada',
  'tickets.filterDateFrom': '{label} dari',
  'tickets.filterDateTo': '{label} hingga',
  'tickets.filterDateTo2': 'hingga',
  'tickets.filterAny': 'Apa pun',
  'tickets.chipFieldStatus': 'Status',
  'tickets.chipFieldPriority': 'Prioritas',
  'tickets.chipFieldGroup': 'Grup',
  'tickets.chipFieldAssignee': 'Penerima tugas',
  'tickets.chipValueGroup': 'Grup',
  'tickets.chipValueUnassigned': 'Belum ditugaskan',
  'common.saving': 'Menyimpan…',
  'common.clearSearch': 'Hapus pencarian',
  'common.sortBy': 'Urutkan berdasarkan',
  'common.name': 'Nama',
  'common.role': 'Peran',
  'common.groups': 'Grup',
  'common.tickets': 'Tiket',
  'common.lastSeen': 'Terakhir dilihat',
  'common.actions': 'Tindakan',
  'common.never': 'Tidak pernah',
  'common.justNow': 'Baru saja',
  'common.minutesAgo': '{count} mnt lalu',
  'common.hoursAgo': '{count} jam lalu',
  'common.daysAgo': '{count} hr lalu',
  'common.noPagePermission': 'Anda tidak memiliki izin untuk mengakses halaman ini.',
  'common.roleNoPermission': 'Peran Anda tidak memiliki izin untuk mengakses halaman ini.',
  'common.requestFailed': 'Permintaan gagal. Silakan coba lagi.',
  'common.unexpectedError': 'Terjadi kesalahan yang tidak terduga',
  'common.user': 'Pengguna',
  'shell.skipToMain': 'Lompat ke konten utama',
  'shell.homeLabel': 'Beranda Suzuki Support Desk',
  'shell.userMenu': 'Menu pengguna',
  'shell.unread': '{count} belum dibaca',
  'shell.adminNavigation': 'Navigasi admin',
  'shell.notificationDescription': 'Penugasan baru, balasan, dan peringatan SLA akan muncul di sini.',
  'auth.enterAuthenticatorCode': 'Masukkan kode 6 digit dari aplikasi autentikator Anda',
  'auth.verifying': 'Memverifikasi…',
  'auth.setupAuthenticator': 'Siapkan Autentikator',
  'auth.scanAuthenticator': 'Pindai kode ini dengan aplikasi autentikator Anda (Google Authenticator, Authy, dll.)',
  'auth.authenticatorSetupQr': 'Kode QR penyiapan autentikator',
  'auth.verificationCodeFromAuthenticator': 'Kode verifikasi dari autentikator',
  'auth.verifyAndComplete': 'Verifikasi dan Selesaikan Penyiapan',
  'auth.loadingSetup': 'Memuat penyiapan…',
  'auth.setNewPassword': 'Atur Kata Sandi Baru',
  'auth.temporaryPasswordExpired': 'Kata sandi sementara Anda telah kedaluwarsa. Silakan atur kata sandi baru.',
  'auth.newPassword': 'Kata sandi baru',
  'auth.confirmPassword': 'Konfirmasi kata sandi',
  'auth.settingPassword': 'Mengatur kata sandi…',
  'auth.setPassword': 'Atur Kata Sandi',
  'auth.passwordRequirements': 'Diperlukan 8+ karakter, huruf besar, huruf kecil, angka, dan simbol',
  'auth.tooManyAttempts': 'Terlalu banyak percobaan masuk. Silakan coba lagi nanti.',
  'auth.invalidCredentials': 'Email atau kata sandi tidak valid',
  'auth.passwordsDoNotMatch': 'Kata sandi tidak cocok',
  'auth.passwordMinimum': 'Kata sandi harus minimal {count} karakter',
  'auth.resetTitle': 'Atur ulang kata sandi Anda',
  'auth.resetSubtitle': 'Masukkan email Anda dan kami akan mengirimkan tautan atur ulang',
  'auth.checkEmail': 'Periksa email Anda untuk tautan atur ulang',
  'auth.checkCode': 'Periksa email Anda untuk mendapatkan kode verifikasi, lalu lanjutkan di bawah.',
  'auth.continueToReset': 'Lanjutkan untuk mengatur ulang kata sandi',
  'auth.sendResetLink': 'Kirim tautan atur ulang',
  'auth.sending': 'Mengirim…',
  'auth.resetSuccess': 'Kata sandi Anda berhasil diatur ulang.',
  'auth.goToLogin': 'Buka halaman masuk',
  'auth.missingResetToken': 'Token atur ulang tidak ada. Gunakan tautan dari email Anda.',
  'auth.enterCodeFromEmail': 'Masukkan kode verifikasi yang dikirim ke email Anda',
  'auth.codeFromEmail': 'Masukkan kode dari email',
  'auth.emailRequired': 'Email diperlukan',
  'auth.codeRequired': 'Kode verifikasi diperlukan',
  'auth.missingToken': 'Token atur ulang tidak ada',
  'auth.failedReset': 'Gagal mengatur ulang kata sandi.',
  'auth.resetting': 'Mengatur ulang…',
  'auth.resetPassword': 'Atur ulang kata sandi',
  'auth.looksGood': 'Terlihat bagus',
  'auth.needCharacters': 'Perlu minimal {count} karakter',
  'auth.passwordFormat': 'Diperlukan {count}+ karakter, huruf besar, huruf kecil, angka, dan simbol',
  'agents.description': 'Orang-orang yang menangani tiket. Tetapkan peran untuk mengontrol apa yang dapat mereka lakukan, dan grup untuk mengontrol apa yang mereka lihat.',
  'agents.searchAria': 'Cari agen',
  'agents.countOne': '{count} agen',
  'agents.countMany': '{count} agen',
  'agents.ticketOne': '{count} tiket',
  'agents.ticketMany': '{count} tiket',
  'agents.noGroups': 'Tidak ada grup',
  'agents.lifecycle': 'Siklus hidup agen',
  'agents.noSearchResults': 'Tidak ada agen yang cocok dengan pencarian ini',
  'agents.noAgentsView': 'Tidak ada agen dalam tampilan ini',
  'agents.tryDifferent': 'Coba nama atau alamat email yang berbeda.',
  'agents.useNewAgent': 'Gunakan Agen Baru untuk menambahkan seseorang, atau beralih tab untuk melihat agen lain.',
  'agents.agent': 'Agen',
  'agents.noRole': 'Tidak ada peran',
  'agents.openTicketsTitle': 'Tiket terbuka yang saat ini ditugaskan ke agen ini',
  'agents.moreActions': 'Tindakan lainnya untuk {name}',
  'agents.confirmDeleteTitle': 'Hapus {name}?',
  'agents.confirmDeleteDescription': 'Tindakan ini tidak dapat dibatalkan. Agen yang terkait dengan tiket tidak dapat dihapus; nonaktifkan sebagai gantinya.',
  'agents.confirmDeleteLabel': 'Hapus agen',
  'agents.agentsVsCollaborators': 'Agen vs Kolaborator',
  'agents.agentsVsCollaboratorsBody': 'Agen Dukungan menangani tiket setiap hari. Kolaborator memiliki peran kolaborator dan biasanya ahli materi yang dilibatkan pada tiket tertentu tanpa akses agen penuh.',
  'agents.deactivateVsDelete': 'Nonaktifkan vs Hapus',
  'agents.deactivateVsDeleteBody': 'Menonaktifkan menjaga riwayat dan kepemilikan tiket tetap utuh tetapi memblokir masuk. Hapus bersifat permanen dan hanya berfungsi jika agen tidak memiliki tiket terkait.',
  'agents.newTitle': 'Agen Baru',
  'agents.editTitle': 'Ubah Agen',
  'agents.temporaryPassword': 'Kata sandi sementara',
  'agents.passwordHelp': 'Minimal 12 karakter. Agen dapat mengubahnya setelah masuk.',
  'agents.timezoneHelp': 'Setiap tanggal dan waktu yang dilihat agen ini ditampilkan dalam zona waktu ini.',
  'agents.languageHelp': 'Menerjemahkan antarmuka yang dihadapi agen. Balasan tiket dan konten pelanggan tidak diterjemahkan.',
  'agents.signaturePlaceholder': 'Ditambahkan ke balasan keluar',
  'agents.roleHelp': 'Menentukan apa yang dapat dilakukan agen ini.',
  'agents.manageRoles': 'Kelola peran',
  'agents.activeHelp': 'Aktif — menghapus centang memblokir masuk tanpa menghapus agen',
  'agents.groupHelp': 'Tambahkan agen ini ke grup dari layar Grup untuk mengontrol tiket mana yang mereka lihat.',
  'agents.about': 'Tentang agen ini',
  'agents.aboutBody': 'Nama, email, telepon, zona waktu, bahasa, dan tanda tangan mengidentifikasi agen dan mempersonalisasi ruang kerja mereka. Peran mengontrol apa yang dapat mereka lakukan; keanggotaan grup mengontrol tiket mana yang mereka lihat.',
  'dashboard.trendsDescription': 'Pembuatan tiket berdasarkan jam UTC, dibandingkan dengan kemarin.',
  'dashboard.today': 'Hari ini',
  'dashboard.yesterday': 'Kemarin',
  'dashboard.chartAria': 'Volume tiket berdasarkan jam UTC, hari ini versus kemarin',
  'dashboard.dataUnavailable': 'Data dasbor tidak tersedia.',
  'dashboard.loadError': 'Tidak dapat memuat data dasbor. Silakan coba lagi.',
  'notifications.noType': 'Tidak ada notifikasi jenis ini',
  'notifications.allTypesHint': 'Pilih "Semua jenis" di atas untuk melihat sisa riwayat Anda.',
  'notifications.emptyDescription': 'Penugasan, balasan, dan peringatan SLA muncul di sini. Sesuaikan mana yang mengirimi Anda email di preferensi notifikasi.',
  'preferences.digestWarning': 'Anda menggunakan ringkasan harian, sehingga pengaturan ini diabaikan sampai Anda menonaktifkannya.',
  'preferences.assignedEvent': 'Tiket ditugaskan kepada Anda',
  'preferences.replyEvent': 'Tiket yang Anda ikuti mendapat balasan',
  'preferences.noteEvent': 'Catatan pribadi ditambahkan',
  'preferences.slaWarningEvent': 'SLA mendekati tenggat waktunya',
  'preferences.slaBreachEvent': 'SLA dilanggar',
  'preferences.slaEscalationEvent': 'SLA meningkat melewati tenggat waktu',
  'preferences.mentionEvent': 'Anda disebut pada tiket',

  'ticketDetail.back': 'Kembali',
  'ticketDetail.follow': 'Ikuti',
  'ticketDetail.following': 'Mengikuti',
  'ticketDetail.hideActivities': 'Sembunyikan aktivitas',
  'ticketDetail.activitiesButton': 'Aktivitas',
  'ticketDetail.attachmentsCount': 'Lampiran ({count})',
  'ticketDetail.threadAria': 'Utas tiket',
  'ticketDetail.conversationsTabLabel': 'Percakapan',
  'ticketDetail.activitiesTabLabel': 'Aktivitas',
  'ticketDetail.noRepliesYet': 'Belum ada balasan',
  'ticketDetail.noRepliesDescription': 'Gunakan editor di bawah untuk membalas pemohon atau menambahkan catatan internal.',
  'ticketDetail.privateNote': 'Catatan Pribadi',
  'ticketDetail.forward': 'Diteruskan',
  'ticketDetail.uploadingAria': 'Mengunggah',
  'ticketDetail.uploadingProgress': 'Mengunggah {uploading} dari {total} berkas…',
  'ticketDetail.uploadsFailed': '{count} unggahan gagal',
  'ticketDetail.retry': 'Coba lagi',
  'ticketDetail.dismiss': 'Tutup',
  'ticketDetail.noActivityYet': 'Belum ada aktivitas',
  'ticketDetail.noActivityDescription': 'Perubahan status, agen, dan SLA akan tercantum di sini saat tiket berjalan.',
  'ticketDetail.requester': 'Pemohon',
  'ticketDetail.properties': 'Properti',
  'ticketDetail.updating': 'Memperbarui…',
  'ticketDetail.update': 'Perbarui',
  'ticketDetail.tags': 'Tag',
  'ticketDetail.relationships': 'Hubungan',
  'ticketDetail.parentTicket': 'Tiket induk',
  'ticketDetail.unlink': 'Putuskan tautan',
  'ticketDetail.noParentTicket': 'Tidak ada tiket induk',
  'ticketDetail.childTicketsCount': 'Tiket anak ({count})',
  'ticketDetail.noChildTickets': 'Tidak ada tiket anak',
  'ticketDetail.findTicket': 'Cari tiket',
  'ticketDetail.ticketSearchPlaceholder': 'Nomor tiket atau subjek',
  'ticketDetail.searchButton': 'Cari',
  'ticketDetail.setParent': 'Jadikan induk',
  'ticketDetail.mergeIntoAction': 'Gabungkan ke',
  'ticketDetail.splitIntoChild': 'Pisahkan menjadi tiket anak',
  'ticketDetail.newTicketSubjectPlaceholder': 'Subjek tiket baru',
  'ticketDetail.splitButton': 'Pisahkan',
  'ticketDetail.copyAttachments': 'Salin lampiran',
  'ticketDetail.copyConversationHistory': 'Salin riwayat percakapan',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Dijeda',
  'ticketDetail.editButton': 'Ubah',
  'ticketDetail.setResolutionDueDate': 'Atur tenggat penyelesaian',
  'ticketDetail.pickDateTime': 'Pilih tanggal & waktu',
  'ticketDetail.resolutionDueLabel': 'Tenggat penyelesaian',
  'ticketDetail.saveSla': 'Simpan SLA',
  'ticketDetail.savingSla': 'Menyimpan…',
  'ticketDetail.noSlaPolicy': 'Tidak ada kebijakan SLA yang diterapkan pada tiket ini.',
  'ticketDetail.firstResponse': 'Respons Pertama',
  'ticketDetail.resolution': 'Penyelesaian',
  'ticketDetail.done': 'Selesai',
  'ticketDetail.pausedSince': 'Dijeda sejak {date}',
  'ticketDetail.escalation': 'Eskalasi',
  'ticketDetail.escalatedLevel2': 'Dieskalasi (Level 2)',
  'ticketDetail.escalated': 'Dieskalasi',
  'ticketDetail.dueDateOverridden': 'Tenggat waktu ditimpa secara manual oleh admin.',
  'ticketDetail.dates': 'Tanggal',
  'ticketDetail.created': 'Dibuat',
  'ticketDetail.updated': 'Diperbarui',
  'ticketDetail.resolved': 'Diselesaikan',
  'ticketDetail.closed': 'Ditutup',
  'ticketDetail.loadErrorTitle': 'Tidak dapat memuat tiket ini',
  'ticketDetail.notFound': 'Tiket tidak ditemukan',
  'ticketDetail.confirmMergeTitle': 'Gabungkan tiket #{source} ke #{target}?',
  'ticketDetail.confirmMergeDescription': 'Tiket saat ini akan ditutup. Tindakan ini tidak dapat dibatalkan.',
  'ticketDetail.confirmMergeLabel': 'Gabungkan tiket',
  'ticketDetail.updateSuccess': 'Tiket diperbarui',
  'ticketDetail.updateError': 'Tidak dapat memperbarui tiket',
  'ticketDetail.pickDateTitle': 'Pilih tanggal',
  'ticketDetail.pickDateDescription': 'Pilih tenggat penyelesaian.',
  'ticketDetail.slaUpdateSuccess': 'SLA diperbarui',
  'ticketDetail.slaUpdateError': 'Tidak dapat memperbarui SLA',
  'ticketDetail.searchError': 'Tidak dapat mencari tiket',
  'ticketDetail.parentUpdateError': 'Tidak dapat memperbarui tiket induk',
  'ticketDetail.mergeSuccess': 'Digabungkan ke #{number}',
  'ticketDetail.mergeError': 'Tidak dapat menggabungkan tiket',
  'ticketDetail.splitSuccess': 'Pemisahan tiket dibuat',
  'ticketDetail.splitError': 'Tidak dapat memisahkan tiket',
  'ticketDetail.downloadError': 'Tidak dapat mengunduh lampiran',
  'ticketDetail.followSuccess': 'Sekarang mengikuti tiket',
  'ticketDetail.unfollowSuccess': 'Berhenti mengikuti tiket',
  'ticketDetail.watcherError': 'Tidak dapat memperbarui status pengikut',
  'ticketDetail.fieldsLoadError': 'Tidak dapat memuat kolom tiket',
  'ticketDetail.overdueBy': 'Terlambat {label}',
  'ticketDetail.dueLeft': 'Tersisa {label}',
  'ticketDetail.presetToday': 'Hari ini',
  'ticketDetail.presetTomorrow': 'Besok',
  'ticketDetail.presetThisWeek': 'Minggu ini',
  'ticketDetail.presetNextWeek': 'Minggu depan',
  'ticketDetail.presetThisMonth': 'Bulan ini',
  'ticketDetail.eventTicketCreated': 'Tiket dibuat',
  'ticketDetail.eventStatusUpdated': 'Status diperbarui',
  'ticketDetail.eventAgentUpdated': 'Agen diperbarui',
  'ticketDetail.eventSlaUpdated': 'SLA diperbarui',
  'ticketDetail.eventTicketMerged': 'Tiket digabungkan',
  'ticketDetail.eventMergeReceived': 'Penggabungan diterima',
  'ticketDetail.eventTicketSplit': 'Tiket dipisahkan',
  'ticketDetail.eventUpdated': 'Diperbarui',
  'ticketDetail.eventSplitContentCopied': 'Konten pemisahan disalin',
  'ticketDetail.eventReplySent': 'Balasan terkirim',
  'ticketDetail.eventNoteAdded': 'Catatan ditambahkan',
  'ticketDetail.eventCustomerReplied': 'Pelanggan membalas',
  'ticketDetail.eventTicketDeleted': 'Tiket dihapus',
  'preferences.createdEvent': 'Tiket dibuat',
  'preferences.pendingInputEvent': 'Tiket menunggu balasan Anda',
  'preferences.resolvedEvent': 'Tiket telah diselesaikan',
  'agents.assignGroups': 'Tetapkan grup',
  'agents.assignGroupsHelp': 'Keanggotaan grup menentukan tiket yang dapat dilihat agen ini.',
  'agents.selectGroups': 'Pilih grup',
  'agents.ticketVisibility': 'Visibilitas tiket',
  'agents.ticketVisibilityHelp': 'Pilih batasan per agen yang lebih sempit atau gunakan default peran. Izin peran tetap menentukan tindakan yang dapat dilakukan agen.',
  'agents.scopeRoleDefault': 'Gunakan default peran',
  'agents.scopeRoleDefaultHelp': 'Gunakan visibilitas default yang dikonfigurasi untuk peran ini.',
  'agents.scopeAll': 'Semua tiket',
  'agents.scopeAllHelp': 'Lihat semua tiket yang belum dihapus di akun ini.',
  'agents.scopeGroup': 'Tiket dalam grup',
  'agents.scopeGroupHelp': 'Lihat tiket yang ditetapkan ke grup tempat agen ini menjadi anggota.',
  'agents.scopeAssigned': 'Tiket yang ditetapkan',
  'agents.scopeAssignedHelp': 'Lihat tiket yang ditetapkan langsung kepada agen ini.',
  'agents.scopeCollaboratorHelp': 'Kolaborator tetap dibatasi pada tiket dalam grup L1 mereka.',
  'nav.jira': 'Integrasi Jira',
  'notifications.groupAssigned': 'Penugasan grup',
  'notifications.groupMemberAdded': 'Ditambahkan ke grup',
  'preferences.groupAssignedEvent': 'Tiket ditugaskan ke salah satu grup Anda',
  'preferences.groupMemberAddedEvent': 'Anda ditambahkan ke grup dukungan',
  'ui.select': 'Pilih…',
  'ui.any': 'Apa saja',
  'ui.typeToSearch': 'Ketik untuk mencari…',
  'ui.noResults': 'Tidak ada hasil',
  'ui.clearSelection': 'Hapus pilihan',
  'ui.removeItem': 'Hapus {label}',
  'ui.pressEnterToUse': 'Tekan Enter untuk memakai nilai ini',
  'ui.removeFilter': 'Hapus filter {field}: {value}',
  'ui.removeTag': 'Hapus tag {label}',
  'ui.retry': 'Coba lagi',
  'ui.errorTitle': 'Tidak dapat memuat konten ini',
  'ui.errorMessage': 'Periksa koneksi Anda lalu coba lagi.',
  'ui.reference': 'Referensi: {id}',
  'ui.thisArea': 'area ini',
  'ui.noAccess': 'Anda tidak memiliki akses ke {area}',
  'ui.noAccessHint': 'Minta administrator untuk memberikan izin yang diperlukan.',
  'ui.actionFailed': 'Tidak dapat menyelesaikan tindakan ini. Coba lagi.',
  'ui.slaPaused': 'SLA dijeda',
  'ui.filteredEmptyTitle': 'Tidak ada tiket yang cocok dengan filter ini',
  'ui.filteredEmptyDescription': 'Coba hapus filter atau perluas rentang tanggal.',
  'ui.clearFilters': 'Hapus filter',
  'pagination.noResults': 'Tidak ada hasil',
  'pagination.showing': 'Menampilkan {first}–{last} dari {total}',
  'pagination.resultsPerPage': 'Hasil per halaman',
  'pagination.perPage': '{count} per halaman',
  'pagination.previous': 'Sebelumnya',
  'pagination.next': 'Berikutnya',
  'pagination.previousAria': 'Halaman sebelumnya',
  'pagination.nextAria': 'Halaman berikutnya',
  'pagination.pageOf': 'Halaman {page} dari {total}',
  'status.open': 'Terbuka',
  'status.to_be_prioritised': 'Menunggu Prioritas',
  'status.work_in_progress': 'Sedang Dikerjakan',
  'status.assigned_to_ai_agent': 'Ditugaskan ke Agen AI',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Tertunda',
  'status.awaiting_user_reply': 'Menunggu Balasan Pengguna',
  'status.awaiting_resolution_confirmation': 'Menunggu Konfirmasi Penyelesaian',
  'status.on_hold': 'Ditahan',
  'status.pending_production_release': 'Menunggu Rilis Produksi',
  'status.product_cr': 'CR Produk',
  'status.reopened': 'Dibuka Kembali',
  'status.issue_fixed': 'Masalah Diperbaiki',
  'status.resolved': 'Terselesaikan',
  'status.closed': 'Ditutup',
  'status.unknown': 'Tidak diketahui',
  'priority.low': 'Rendah',
  'priority.medium': 'Sedang',
  'priority.high': 'Tinggi',
  'priority.urgent': 'Mendesak',
  'source.email': 'Email',
  'source.portal': 'Portal',
  'source.phone': 'Telepon',
  'source.chat': 'Obrolan',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Obrolan Web',
  'source.web_form': 'Formulir Web',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget Umpan Balik',
  'source.outbound_email': 'Email Keluar',
  'source.ecommerce': 'E-commerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Pesan Instagram',
  'source.instagram_comment': 'Komentar Instagram',
  'source.facebook_message': 'Pesan Facebook',
  'source.facebook_comment': 'Komentar Facebook',
  'source.mobile_chat_sdk': 'SDK Obrolan Seluler',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Tampilan Tersimpan',
  'savedViews.saveCurrent': 'Simpan filter saat ini sebagai tampilan',
  'savedViews.namePlaceholder': 'Nama tampilan...',
  'savedViews.nameAria': 'Nama tampilan',
  'savedViews.empty': 'Belum ada tampilan tersimpan. Terapkan filter dan simpan di sini.',
  'savedViews.listAria': 'Daftar tampilan tersimpan',
  'savedViews.rename': 'Ganti nama tampilan "{name}"',
  'savedViews.delete': 'Hapus tampilan "{name}"',
  'export.title': 'Ekspor tiket',
  'export.loadError': 'Tidak dapat memuat daftar kolom ekspor.',
  'export.failed': 'Ekspor gagal. Silakan coba lagi.',
  'export.pdfFailed': 'Ekspor PDF gagal. Silakan coba lagi.',
  'export.fieldsSelectedOne': '{count} kolom dipilih',
  'export.fieldsSelectedMany': '{count} kolom dipilih',
  'export.fieldsTotalOne': 'Total {count} kolom',
  'export.fieldsTotalMany': 'Total {count} kolom',
  'export.selectAllFields': 'Pilih semua kolom',
  'export.exportingOne': 'Mengekspor 1 tiket yang dipilih.',
  'export.exportingMany': 'Mengekspor {count} tiket yang dipilih.',
  'export.pdfZip': 'Unduh sebagai PDF (.zip, {count} file)',
  'export.pdf': 'Unduh sebagai PDF',
  'export.pdfZipHint': 'Membuat satu PDF per tiket dan mengompresnya menjadi satu unduhan ZIP.',
  'export.pdfHint': 'Membuat satu PDF berisi properti tiket dan percakapan publik.',
  'export.formatLabel': 'Ekspor sebagai (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Memuat daftar kolom…',
  'export.ticketFields': 'Kolom tiket',
  'export.contactFields': 'Kolom kontak',
  'export.companyFields': 'Kolom perusahaan',
  'export.exporting': 'Mengekspor…',
  'newTicket.title': 'Buat Tiket',
  'newTicket.description': 'Pilih formulir yang tersimpan dan lengkapi kolomnya.',
  'newTicket.form': 'Formulir tiket',
  'newTicket.noForms': 'Tidak ada formulir tiket. Konfigurasikan formulir sebelum membuat tiket.',
  'newTicket.loadFormsError': 'Tidak dapat memuat formulir tiket',
  'newTicket.loadFormError': 'Tidak dapat memuat formulir tiket yang dipilih',
  'newTicket.addCc': 'Tambah CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Hapus {name}',
  'newTicket.requesterRequired': 'Pemohon wajib diisi',
  'newTicket.subjectRequired': 'Subjek wajib diisi',
  'newTicket.createFailed': 'Gagal membuat tiket',
  'newTicket.noFormTitle': 'Tidak ada formulir tiket',
  'newTicket.noFormDescription': 'Buat formulir tiket di Pengaturan, lalu kembali untuk membuka tiket.',
  'newTicket.noFieldsTitle': 'Formulir ini belum memiliki kolom',
  'newTicket.noFieldsDescription': 'Tambahkan kolom ke formulir di Pengaturan, lalu muat ulang halaman ini.',
  'newTicket.creating': 'Membuat...',
  'newTicket.submit': 'Buat Tiket',
  'fields.required': '{label} wajib diisi',
  'fields.selectParentFirst': 'Pilih nilai induk terlebih dahulu...',
  'fields.selectPlaceholder': 'Pilih {label}...',
  'fields.enterPlaceholder': 'Masukkan {label}...',
  'fields.optionsLoadError': 'Tidak dapat memuat opsi {label}',
  'fields.label.requester': 'Pemohon',
  'fields.label.subject': 'Subjek',
  'fields.label.description': 'Deskripsi',
  'fields.label.status': 'Status',
  'fields.label.priority': 'Prioritas',
  'fields.label.source': 'Sumber',
  'fields.label.ticket_type': 'Tipe',
  'fields.label.agent': 'Agen',
  'fields.label.group': 'Grup',
  'fields.label.internal_agent': 'Agen Internal',
  'fields.label.internal_group': 'Grup Internal',
  'fields.label.company': 'Perusahaan',
  'editor.defaultPlaceholder': 'Ketik di sini...',
  'editor.ariaLabel': 'Editor teks kaya',
  'editor.toolbarAria': 'Pemformatan teks',
  'editor.bold': 'Tebal (Ctrl+B)',
  'editor.italic': 'Miring (Ctrl+I)',
  'editor.underline': 'Garis bawah (Ctrl+U)',
  'editor.strikethrough': 'Coret',
  'editor.heading1': 'Judul 1',
  'editor.heading2': 'Judul 2',
  'editor.textColor': 'Warna teks',
  'editor.highlight': 'Sorot',
  'editor.bulletList': 'Daftar Berpoin',
  'editor.numberedList': 'Daftar Bernomor',
  'editor.blockquote': 'Kutipan',
  'editor.codeBlock': 'Blok Kode',
  'editor.insertLink': 'Sisipkan Tautan',
  'editor.insertImage': 'Sisipkan Gambar',
  'editor.insertTable': 'Sisipkan Tabel',
  'editor.mention': 'Sebut seseorang',
  'editor.undo': 'Urungkan (Ctrl+Z)',
  'editor.redo': 'Ulangi (Ctrl+Shift+Z)',
  'editor.attach': 'Lampirkan file',
  'editor.noAgents': 'Agen tidak ditemukan',
  'editor.mentionSuggestions': 'Saran sebutan',
  'editor.dialogLinkTitle': 'Sisipkan tautan',
  'editor.dialogImageTitle': 'Sisipkan gambar',
  'editor.linkHint': 'Masukkan URL HTTP(S), mailto, anchor, atau relatif.',
  'editor.imageHint': 'Masukkan URL gambar HTTP(S) atau relatif.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Masukkan URL HTTP(S), mailto, anchor, atau relatif yang valid.',
  'editor.invalidImage': 'Masukkan URL gambar HTTP(S) atau relatif yang valid.',
  'editor.selectTextForLink': 'Pilih teks sebelum menambahkan tautan.',
  'editor.imageInsertFailed': 'Gambar tidak dapat disisipkan di sini.',
  'editor.insertLinkAction': 'Sisipkan tautan',
  'editor.insertImageAction': 'Sisipkan gambar',
  'search.dialogAria': 'Pencarian global',
  'search.placeholder': 'Cari tiket, kontak...',
  'search.aria': 'Cari',
  'search.close': 'Tutup pencarian',
  'search.noMatches': 'Tidak ada hasil untuk “{query}”',
  'search.noMatchesHint': 'Coba nomor tiket, email kontak, atau nama perusahaan.',
  'search.hintBefore': 'Ketik minimal 2 karakter untuk mencari. Tekan',
  'search.hintAfter': 'untuk menutup.',

  'td.system': 'Sistem',
  'td.actionCreatedTicket': 'membuat tiket',
  'td.actionUpdatedFields': 'memperbarui {fields}',
  'td.fieldStatus': 'status',
  'td.fieldPriority': 'prioritas',
  'td.fieldSource': 'sumber',
  'td.fieldType': 'jenis',
  'td.fieldGroup': 'grup',
  'td.fieldAgent': 'agen',
  'td.fieldCompany': 'perusahaan',
  'td.fieldContact': 'kontak',
  'td.fieldSubject': 'subjek',
  'td.fieldDescription': 'deskripsi',
  'td.fieldProduct': 'produk',
  'td.fieldResolutionDue': 'tanggal jatuh tempo penyelesaian',
  'td.fieldFirstResponseDue': 'tanggal jatuh tempo respons pertama',
  'td.fieldTags': 'tag',
  'td.fieldParentTicket': 'tiket induk',
  'td.eventCreated': '{actor} membuat tiket baru',
  'td.eventCreatedLinked': '{actor} membuat tiket baru dan menautkannya ke tiket induk',
  'td.eventSplit': '{actor} memisahkan tiket ini dan membuat tiket turunan{ref}',
  'td.eventMergeReceived': '{actor} menggabungkan tiket lain ke tiket ini{ref}',
  'td.eventMerged': '{actor} menggabungkan tiket ini ke tiket lain{ref}',
  'td.eventSplitCopied': '{actor} menyalin {conversations} dan {attachments}',
  'td.conversationsOne': '{count} percakapan',
  'td.conversationsMany': '{count} percakapan',
  'td.attachmentsOne': '{count} lampiran',
  'td.attachmentsMany': '{count} lampiran',
  'td.eventUpdatedFields': '{actor} memperbarui {fields}',
  'td.invalidSlaState': 'Server mengembalikan status SLA yang tidak valid.',
  'td.slaRefreshError': 'Tidak dapat menyegarkan jam SLA.',
  'td.descriptionUpdated': 'Deskripsi diperbarui',
  'td.descriptionUpdateError': 'Tidak dapat memperbarui deskripsi',
  'td.descriptionUpdateFailed': 'Pembaruan deskripsi gagal',
  'td.entryUpdated': 'Entri diperbarui',
  'td.entryUpdateError': 'Tidak dapat memperbarui entri',
  'td.updateFailed': 'Pembaruan gagal',
  'td.loadOlderError': 'Tidak dapat memuat percakapan sebelumnya',
  'td.loadFailed': 'Gagal memuat',
  'td.slaUpdateFailed': 'Pembaruan SLA gagal',
  'td.reasonTooLong': 'Alasan maksimal 500 karakter.',
  'td.invalidDateTime': 'Pilih tanggal dan waktu yang valid.',
  'td.slaDeadlineUpdated': 'Tenggat SLA diperbarui',
  'td.slaConflict': 'Tiket berubah saat Anda mengedit data SLA. Muat ulang sebelum mencoba lagi.',
  'td.slaClearFailed': 'Gagal menghapus SLA',
  'td.slaTargetCleared': 'Target SLA dihapus',
  'td.slaClearError': 'Tidak dapat menghapus target SLA',
  'td.noDescription': 'Belum ada deskripsi.',
  'td.editDescriptionAria': 'Edit deskripsi tiket',
  'td.download': 'Unduh',
  'td.downloadFile': 'Unduh {fileName}',
  'td.loadOlder': '↓ +{count} percakapan',
  'td.loadOlderMany': '↓ +{count} percakapan',
  'td.edited': '(diedit)',
  'td.privateThread': 'Utas privat',
  'td.propertiesAria': 'Properti tiket',
  'td.expandProperties': 'Perluas properti',
  'td.collapseProperties': 'Ciutkan properti',
  'td.metric': 'Metrik',
  'td.firstResponseOption': 'Respons pertama',
  'td.resolutionOption': 'Penyelesaian',
  'td.overrideHint': 'Tetapkan penimpaan tenggat yang berwenang di server. Alasan disimpan dalam riwayat SLA.',
  'td.deadline': 'Tenggat',
  'td.reasonOptional': 'Alasan (opsional)',
  'td.reasonPlaceholder': 'Pengecualian yang disetujui atau konteks operasional',
  'td.clearResolutionOverride': 'Hapus penimpaan penyelesaian',
  'td.clearEscalationTarget': 'Hapus target eskalasi',
  'td.toolsAria': 'Alat tiket dan kontak',
  'td.ticketContext': 'Konteks tiket',
  'td.knowledgeBase': 'Basis pengetahuan',
  'td.shortcutsAria': 'Pintasan konteks tiket',
  'td.showContext': 'Tampilkan konteks tiket',
  'td.hideContext': 'Sembunyikan konteks tiket',
  'td.openRow': 'Buka {label}',
  'td.editTicket': 'Edit tiket',
  'td.searchContactPlaceholder': 'Cari kontak…',
  'td.describePlaceholder': 'Jelaskan masalahnya…',
  'td.noAttachments': 'Tidak ada lampiran',

  'tp.api.csrfUnavailable': 'Tidak dapat membuat perlindungan CSRF',
  'tp.api.noMfaChallenge': 'Tidak ada tantangan MFA yang aktif',
  'tp.api.noMfaSetup': 'Tidak ada tantangan penyiapan MFA yang aktif',
  'tp.api.noNewPasswordChallenge': 'Tidak ada tantangan kata sandi baru yang aktif',
  'tp.articles.isLinkedAria': '{title} ditautkan sebagai solusi',
  'tp.articles.linkAria': 'Tautkan {title} sebagai solusi',
  'tp.articles.linkAsSolution': 'Tautkan sebagai solusi',
  'tp.articles.linkedAsSolution': 'Ditautkan sebagai solusi',
  'tp.articles.none': 'Tidak ada artikel yang disarankan untuk tiket ini.',
  'tp.articles.title': 'Artikel yang Disarankan',
  'tp.articles.views': '{count} tayangan',
  'tp.attachment.loadingPreview': 'Memuat pratinjau…',
  'tp.attachment.previewUnavailable': 'Pratinjau tidak tersedia',
  'tp.charts.noData': 'Tidak ada data grafik untuk periode ini.',
  'tp.charts.noRecords': 'Tidak ada catatan pada periode ini.',
  'tp.charts.period': 'Periode',
  'tp.charts.showingTop': 'Menampilkan {shown} teratas dari {total} segmen.',
  'tp.common.cancel': 'Batal',
  'tp.common.clear': 'Hapus',
  'tp.common.loading': 'Memuat…',
  'tp.common.send': 'Kirim',
  'tp.common.sending': 'Mengirim…',
  'tp.common.system': 'Sistem',
  'tp.convActions.edit': 'Edit',
  'tp.convActions.thread': 'Mulai utas',
  'tp.dashboard.new': 'Baru',
  'tp.dashboard.select': 'Pilih Dasbor',
  'tp.forward.failed': 'Gagal meneruskan',
  'tp.forward.forwarded': 'Tiket diteruskan',
  'tp.forward.forwarding': 'Meneruskan…',
  'tp.forward.forwardingMany': 'Meneruskan {count} percakapan:',
  'tp.forward.forwardingOne': 'Meneruskan 1 percakapan:',
  'tp.forward.message': 'Pesan',
  'tp.forward.messagePlaceholder': 'Tambahkan pesan (opsional)…',
  'tp.forward.noContacts': 'Kontak tidak ditemukan — ketik alamat email lengkap',
  'tp.forward.recipientEmail': 'Email penerima',
  'tp.forward.recipientInvalid': 'Masukkan alamat email penerima yang valid',
  'tp.forward.recipientRequired': 'Email penerima wajib diisi',
  'tp.forward.searchContact': 'Cari kontak atau ketik email…',
  'tp.forward.title': 'Teruskan',
  'tp.forward.to': 'Kepada',
  'tp.forward.useThisEmail': 'Tekan Enter atau klik Teruskan untuk menggunakan email ini',
  'tp.jira.addOptional': 'Tambah Kolom Opsional',
  'tp.jira.createAndLink': 'Buat dan Tautkan Isu',
  'tp.jira.createIssue': 'Buat Isu',
  'tp.jira.createTitle': 'Buat Isu Jira',
  'tp.jira.describePlaceholder': 'Jelaskan masalahnya…',
  'tp.jira.description': 'Deskripsi',
  'tp.jira.development': 'Pengembangan',
  'tp.jira.enterDevelopment': 'Masukkan pengembangan',
  'tp.jira.hideOptional': 'Sembunyikan Kolom Opsional',
  'tp.jira.issueId': 'ID Isu',
  'tp.jira.issueSummary': 'Ringkasan Isu',
  'tp.jira.issueType': 'Jenis Isu *',
  'tp.jira.lastSync': 'Sinkronisasi terakhir: {error}',
  'tp.jira.linkIssue': 'Tautkan Isu',
  'tp.jira.linkTitle': 'Tautkan Isu Jira',
  'tp.jira.linkedIssues': 'Isu Tertaut',
  'tp.jira.linkedIssuesHint': 'Gunakan kunci isu Jira yang dipisahkan koma.',
  'tp.jira.linkedIssuesPlaceholder': 'mis. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Memuat kolom Jira…',
  'tp.jira.loadingIssueTypes': 'Memuat jenis isu…',
  'tp.jira.loadingProjects': 'Memuat proyek Jira…',
  'tp.jira.loadingUsers': 'Memuat pengguna Jira…',
  'tp.jira.noLinks': 'Belum ada isu Jira yang ditautkan ke tiket ini.',
  'tp.jira.noneFound': 'Isu Jira tidak ditemukan.',
  'tp.jira.notAvailableProject': 'Tidak tersedia untuk proyek ini',
  'tp.jira.projects': 'Proyek *',
  'tp.jira.refresh': 'Segarkan',
  'tp.jira.refreshFields': 'Segarkan kolom Jira',
  'tp.jira.reporter': 'Pelapor',
  'tp.jira.requestFailed': 'Permintaan Jira gagal. Silakan coba lagi.',
  'tp.jira.searchBy': 'Cari berdasarkan:',
  'tp.jira.searchIssue': 'Cari isu',
  'tp.jira.searchIssuePlaceholder': 'Cari isu…',
  'tp.jira.searchUsers': 'Cari pengguna Jira',
  'tp.jira.searching': 'Mencari di Jira…',
  'tp.jira.selectIssueType': 'Pilih jenis isu',
  'tp.jira.selectProject': 'Pilih proyek',
  'tp.jira.summary': 'Ringkasan *',
  'tp.jira.syncOff': 'Sinkronisasi nonaktif',
  'tp.jira.syncOn': 'Sinkronisasi aktif',
  'tp.jira.syncStatus': 'Sinkronkan status tiket ke Jira',
  'tp.jira.unassigned': 'Belum ditugaskan',
  'tp.jira.unlink': 'Lepas tautan',
  'tp.jira.unlinkConfirm': 'Lepas tautan isu',
  'tp.jira.unlinkDescription': 'Ini menghapus koneksi dari tiket tetapi tidak menghapus isu Jira.',
  'tp.jira.unlinkTitle': 'Lepas tautan {key}?',
  'tp.jira.untitled': 'Isu Jira tanpa judul',
  'tp.layout.loadingPage': 'Memuat halaman…',
  'tp.notFound.goToDashboard': 'Buka Dasbor',
  'tp.notFound.title': 'Halaman tidak ditemukan',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Pelanggan',
  'tp.reply.addNote': 'Tambah Catatan',
  'tp.reply.attachmentNotAdded': 'Lampiran tidak ditambahkan',
  'tp.reply.clickToExpand': 'Klik untuk memperluas',
  'tp.reply.collapsedNote': 'Tambahkan catatan internal…',
  'tp.reply.collapsedReply': 'Tulis balasan atau catatan…',
  'tp.reply.conversationType': 'Jenis percakapan',
  'tp.reply.failedToSend': 'Gagal mengirim',
  'tp.reply.markNoteAs': 'Tandai catatan sebagai',
  'tp.reply.notVisibleToContact': 'Tidak terlihat oleh kontak',
  'tp.reply.notVisibleToContacts': 'Tidak terlihat oleh kontak',
  'tp.reply.noteAdded': 'Catatan ditambahkan',
  'tp.reply.notifyTo': 'Beri tahu',
  'tp.reply.placeholderPrivateNote': 'Tambahkan catatan privat...',
  'tp.reply.placeholderPublicNote': 'Tambahkan catatan publik yang terlihat oleh pemohon...',
  'tp.reply.placeholderReply': 'Ketik balasan Anda...',
  'tp.reply.private': 'Privat',
  'tp.reply.public': 'Publik',
  'tp.reply.removeFile': 'Hapus {name}',
  'tp.reply.replySent': 'Balasan terkirim',
  'tp.reply.searchAgentsToNotify': 'Cari agen untuk diberi tahu…',
  'tp.reply.sendReply': 'Kirim Balasan',
  'tp.reply.sending': 'Mengirim...',
  'tp.reply.tabNote': 'Catatan',
  'tp.reply.tabReply': 'Balasan',
  'tp.reply.uploadAttachment': 'Unggah lampiran',
  'tp.reply.visibleToContact': 'Terlihat oleh kontak',
  'tp.reply.visibleToContacts': 'Terlihat oleh kontak',
  'tp.sla.breached': 'Dilanggar',
  'tp.sla.cleared': 'Dihapus',
  'tp.sla.configErrorNoDeadline': 'Kesalahan konfigurasi SLA. Tidak ada tenggat yang diperkirakan.',
  'tp.sla.configurationError': 'Kesalahan konfigurasi',
  'tp.sla.couldNotLoad': 'Tidak dapat memuat jam SLA',
  'tp.sla.done': 'Selesai',
  'tp.sla.dueIn': 'Jatuh tempo dalam {duration}',
  'tp.sla.dueLine': 'Jatuh tempo: {date}',
  'tp.sla.dueNow': 'Jatuh tempo sekarang',
  'tp.sla.escalated': 'Dieskalasi',
  'tp.sla.firstResponse': 'Respons pertama',
  'tp.sla.invalidDeadline': 'Tenggat tidak valid',
  'tp.sla.mayBeStale': 'Jam SLA mungkin sudah usang',
  'tp.sla.noActiveCycle': 'Tidak ada siklus SLA yang aktif.',
  'tp.sla.noDeadline': 'Tanpa tenggat',
  'tp.sla.noMetrics': 'Tidak ada metrik SLA untuk siklus ini.',
  'tp.sla.noPolicy': 'Tidak ada kebijakan SLA yang diterapkan pada tiket ini.',
  'tp.sla.notConfigured': 'Belum dikonfigurasi',
  'tp.sla.notStarted': 'Belum dimulai',
  'tp.sla.overdueBy': 'Terlambat {duration}',
  'tp.sla.overridden': 'Ditimpa',
  'tp.sla.overrideReason': 'Alasan penimpaan: {reason}',
  'tp.sla.paused': 'Dijeda',
  'tp.sla.refreshing': 'Menyegarkan jam SLA resmi…',
  'tp.sla.resolution': 'Penyelesaian',
  'tp.sla.stopsSla': 'Menghentikan SLA',
  'tp.thread.empty': 'Belum ada yang dikirim. Pesan pertama Anda akan memulai utas privat ini.',
  'tp.thread.messageFailed': 'Pesan gagal dikirim',
  'tp.thread.privateThread': 'Utas privat',
  'tp.thread.replyPlaceholder': 'Balas di utas…',
  'tp.thread.someone': 'Seseorang',
  'tp.thread.startPrivateThread': 'Mulai utas privat',
  'tp.thread.startedBy': '{name} memulai utas ini',
  'tp.thread.unableToSend': 'Tidak dapat mengirim pesan',
  'tp.ui.breadcrumb': 'Jejak navigasi',
  'tp.ui.closePanel': 'Tutup panel',
  'tp.ui.dismiss': 'Tutup {title}',

  'dir.loadError': 'Tidak dapat memuat data. Silakan coba lagi.',
  'dir.contacts.description': 'Kontak pelanggan dan riwayat dukungan mereka.',
  'dir.contacts.searchAria': 'Cari kontak',
  'dir.contacts.count': '{count} kontak',
  'dir.contacts.noMatch': 'Tidak ada kontak yang cocok dengan pencarian ini',
  'dir.contacts.none': 'Belum ada kontak',
  'dir.contacts.noneDescription': 'Kontak akan muncul di sini setelah pelanggan mulai mengirim tiket.',
  'dir.company': 'Perusahaan',
  'dir.unnamedContact': 'Kontak tanpa nama',
  'dir.contact': 'Kontak',
  'dir.contactNotFound': 'Kontak tidak ditemukan.',
  'dir.confirmDeleteContactTitle': 'Hapus “{name}”?',
  'dir.thisContact': 'kontak ini',
  'dir.confirmDeleteContactDescription': 'Kontak yang memiliki tiket akan dinonaktifkan, bukan dihapus permanen.',
  'dir.deleteContact': 'Hapus kontak',
  'dir.editProfile': 'Edit profil',
  'dir.profile': 'Profil',
  'dir.firstName': 'Nama depan',
  'dir.lastName': 'Nama belakang',
  'dir.phone': 'Telepon',
  'dir.timezone': 'Zona waktu',
  'dir.emailLabel': 'Email:',
  'dir.phoneLabel': 'Telepon:',
  'dir.companyLabel': 'Perusahaan:',
  'dir.timezoneLabel': 'Zona waktu:',
  'dir.recentTickets': 'Tiket terbaru',
  'dir.noTicketsYet': 'Belum ada tiket',
  'dir.contactTicketsDescription': 'Tiket yang diajukan kontak ini akan tercantum di sini.',
  'dir.ticket': 'Tiket',
  'dir.subject': 'Subjek',
  'dir.status': 'Status',
  'dir.created': 'Dibuat',
  'dir.companies.description': 'Organisasi yang terhubung dengan kontak pelanggan dan tiket.',
  'dir.companies.add': 'Tambah perusahaan',
  'dir.companies.domain': 'Domain',
  'dir.companies.create': 'Buat perusahaan',
  'dir.companies.searchAria': 'Cari perusahaan',
  'dir.companies.searchPlaceholder': 'Cari perusahaan atau domain',
  'dir.companies.noMatch': 'Tidak ada perusahaan yang cocok dengan pencarian ini',
  'dir.companies.addFirst': 'Tambahkan perusahaan pertama Anda',
  'dir.companies.tryDifferent': 'Coba nama perusahaan atau domain lain.',
  'dir.companies.useForm': 'Gunakan formulir di samping daftar ini untuk membuat perusahaan.',
  'dir.companies.contacts': 'Kontak',
  'dir.companies.tickets': 'Tiket',
  'dir.companies.notFound': 'Perusahaan tidak ditemukan.',
  'dir.companies.confirmDeleteTitle': 'Hapus “{name}”?',
  'dir.companies.thisCompany': 'perusahaan ini',
  'dir.companies.confirmDeleteDescription': 'Perusahaan tidak boleh memiliki kontak atau tiket sebelum dapat dihapus.',
  'dir.companies.delete': 'Hapus perusahaan',
  'dir.companies.noDomain': 'Domain belum dikonfigurasi',
  'dir.companies.contactsCount': 'Kontak ({count})',
  'dir.companies.ticketsCount': 'Tiket ({count})',
  'dir.companies.noContactsDescription': 'Tambahkan kontak dan tautkan ke perusahaan ini agar tampil di sini.',
  'dir.companies.noTicketsDescription': 'Tiket yang diajukan kontak perusahaan ini akan tercantum di sini.',
  'dir.trendsCreatedHour': 'Tanggal dibuat - Jam dalam Sehari',
  'dir.reports.loadError': 'Tidak dapat memuat laporan ini. Silakan coba lagi.',
  'dir.reports.volume': 'Volume tiket',
  'dir.reports.sla': 'Kepatuhan SLA',
  'dir.reports.agents': 'Kinerja agen',
  'dir.reports.csat': 'Kepuasan pelanggan',
  'dir.reports.rca': 'Analisis akar masalah',
  'dir.reports.descVolume': 'Lihat dari mana tiket berasal dan bagaimana tiket bergerak dalam siklus hidupnya.',
  'dir.reports.descSla': 'Pantau target respons dan penyelesaian di seluruh operasional dukungan yang dapat diakses.',
  'dir.reports.descAgents': 'Bandingkan beban kerja, hasil, balasan, dan rata-rata waktu penanganan per agen.',
  'dir.reports.descCsat': 'Pahami sentimen pelanggan tanpa mengira volume respons sebagai tingkat kepuasan.',
  'dir.reports.descRca': 'Temukan akar masalah standar di balik permintaan tiket.',
  'dir.reports.noPayload': 'Tidak ada data laporan yang dikembalikan untuk periode ini.',
  'dir.reports.refresh': 'Segarkan',
  'dir.reports.report': 'Laporan',
  'dir.reports.from': 'Dari',
  'dir.reports.to': 'Hingga',
  'dir.reports.maxRange': 'Rentang maksimum: 90 hari · cakupan mengikuti izin akun Anda.',
  'dir.reports.unclassified': 'Belum diklasifikasikan',
  'dir.reports.ticketsInPeriod': 'Tiket dalam periode',
  'dir.reports.ticketsInPeriodDetail': 'Tiket yang dapat diakses yang dikembalikan oleh laporan',
  'dir.reports.created': 'Dibuat',
  'dir.reports.createdDetail': 'Sepanjang sumbu tanggal yang dipilih',
  'dir.reports.resolved': 'Terselesaikan',
  'dir.reports.resolvedDetail': '{percent}% dari volume yang dibuat',
  'dir.reports.noCreated': 'Tidak ada tiket yang dibuat',
  'dir.reports.reopened': 'Dibuka kembali',
  'dir.reports.reopenedDetail': 'Peristiwa siklus hidup, bukan tiket unik',
  'dir.reports.dailyPulse': 'Denyut harian',
  'dir.reports.volumeByDate': 'Volume tiket menurut tanggal',
  'dir.reports.volumeByDateDescription': 'Baris backend yang jarang diperluas menjadi sumbu tanggal lengkap yang terisi nol.',
  'dir.reports.createdTickets': 'Tiket dibuat',
  'dir.reports.createdVolumeAria': 'Volume tiket dibuat menurut tanggal',
  'dir.reports.lifecycle': 'Siklus hidup',
  'dir.reports.lifecycleTitle': 'Dibuat, terselesaikan, dibuka kembali',
  'dir.reports.lifecycleDescription': 'Tampilan tiga garis dari pergerakan tiket sepanjang siklus hidupnya.',
  'dir.reports.lifecycleAria': 'Peristiwa siklus hidup tiket menurut tanggal',
  'dir.reports.dimensions': 'Dimensi',
  'dir.reports.whereConcentrated': 'Di mana volume terkonsentrasi',
  'dir.reports.topEight': 'Delapan segmen teratas ditampilkan per panel',
  'dir.reports.status': 'Status',
  'dir.reports.statusDescription': 'Status tiket saat ini',
  'dir.reports.priority': 'Prioritas',
  'dir.reports.priorityDescription': 'Komposisi prioritas tiket',
  'dir.reports.group': 'Grup',
  'dir.reports.groupDescription': 'Grup perutean',
  'dir.reports.agent': 'Agen',
  'dir.reports.agentDescription': 'Kepemilikan yang ditugaskan',
  'dir.reports.product': 'Produk',
  'dir.reports.productDescription': 'Komposisi produk',
  'dir.reports.country': 'Negara',
  'dir.reports.countryDescription': 'Dari kolom negara yang distandarkan',
  'dir.reports.noRecords': 'Tidak ada catatan pada periode ini.',
  'dir.reports.slaSummary': '{rate} · {met} dari {total} terpenuhi',
  'dir.reports.noSlaSegments': 'Belum ada segmen SLA',
  'dir.reports.noSlaSegmentsDescription': 'Tidak ada catatan SLA yang berlaku untuk dimensi ini pada periode yang dipilih.',
  'dir.reports.segment': 'Segmen',
  'dir.reports.firstResponse': 'Respons pertama',
  'dir.reports.resolution': 'Penyelesaian',
  'dir.reports.avgFirstResponse': 'Rata-rata respons pertama',
  'dir.reports.avgResolution': 'Rata-rata penyelesaian',
  'dir.reports.fromTicketMetric': 'Dari TicketMetric',
  'dir.reports.slaLens': 'Sudut pandang SLA',
  'dir.reports.performanceBySegment': 'Kinerja menurut segmen',
  'dir.reports.slaRatesNote': 'Tingkat hanya menggunakan catatan dengan target SLA yang berlaku. Durasi adalah rata-rata waktu yang berlalu.',
  'dir.reports.slaDimensionAria': 'Dimensi rincian SLA',
  'dir.reports.rosterSignal': 'Sinyal daftar agen',
  'dir.reports.agentPerformance': 'Kinerja agen',
  'dir.reports.agentPerformanceDescription': 'Setiap agen aktif disertakan, termasuk agen tanpa aktivitas.',
  'dir.reports.filterAgentsAria': 'Filter agen',
  'dir.reports.filterAgentsPlaceholder': 'Filter berdasarkan agen atau email',
  'dir.reports.matchingAgents': '{count} agen yang cocok',
  'dir.reports.activeAgents': '{count} agen aktif',
  'dir.reports.sortedBy': 'diurutkan berdasarkan {key} {direction}',
  'dir.reports.asc': 'naik',
  'dir.reports.desc': 'turun',
  'dir.reports.noAgentsMatch': 'Tidak ada agen yang cocok dengan filter ini',
  'dir.reports.assigned': 'Ditugaskan',
  'dir.reports.replies': 'Balasan',
  'dir.reports.csatScore': 'Skor CSAT',
  'dir.reports.csatScoreDetail': 'Peringkat 4 atau 5',
  'dir.reports.averageRating': 'Peringkat rata-rata',
  'dir.reports.averageRatingDetail': 'Dari seluruh survei yang diberi peringkat',
  'dir.reports.ratedSurveys': 'Survei yang diberi peringkat',
  'dir.reports.ratedSurveysDetail': 'Pada periode yang dipilih',
  'dir.reports.satisfied': 'Puas',
  'dir.reports.satisfiedDetail': 'Respons positif',
  'dir.reports.responseTrend': 'Tren respons',
  'dir.reports.surveyVolume': 'Volume survei menurut tanggal',
  'dir.reports.surveyVolumeDescription': 'Backend mengembalikan jumlah respons per tanggal; ini bukan skor harian. 100 respons terbaru disampel di bawah.',
  'dir.reports.surveyResponses': 'Respons survei',
  'dir.reports.surveyVolumeAria': 'Volume respons survei CSAT menurut tanggal',
  'dir.reports.responsesByGroup': 'Respons menurut grup',
  'dir.reports.responsesByGroupDescription': 'Jumlah respons survei, bukan tingkat kepuasan grup',
  'dir.reports.responsesByAgent': 'Respons menurut agen',
  'dir.reports.responsesByAgentDescription': 'Jumlah respons survei, bukan tingkat kepuasan agen',
  'dir.reports.customerVoice': 'Suara pelanggan',
  'dir.reports.latestSurveys': 'Respons survei terbaru',
  'dir.reports.boundedSample': 'Sampel terbatas · {count} dari maks 100',
  'dir.reports.latestSurveysNote': 'Respons terbaru yang dikembalikan oleh API pelaporan. Gunakan tabel ini untuk gambaran cepat, bukan ekspor lengkap.',
  'dir.reports.noSurveys': 'Tidak ada respons survei',
  'dir.reports.noSurveysDescription': 'Respons CSAT akan muncul di sini setelah pelanggan menilai tiket yang terselesaikan.',
  'dir.reports.rating': 'Peringkat',
  'dir.reports.comment': 'Komentar',
  'dir.reports.received': 'Diterima',
  'dir.reports.ratingOutOf': '{rating} dari 5',
  'dir.reports.noComment': 'Tidak ada komentar',
  'dir.reports.rcaEyebrow': 'Analisis akar masalah',
  'dir.reports.rcaTitle': 'Mengapa tiket diajukan',
  'dir.reports.rcaDescription': 'Kategori dan subkategori adalah agregat independen dari kolom kustom tiket yang distandarkan.',
  'dir.reports.rcaDimensionAria': 'Dimensi RCA',
  'dir.reports.category': 'Kategori',
  'dir.reports.subcategory': 'Subkategori',
  'dir.reports.rcaEmpty': 'Tidak ada nilai akar masalah yang dicatat untuk periode ini.',
  'dir.kb.articleLoadError': 'Tidak dapat memuat artikel.',
  'dir.kb.articleNotFound': 'Artikel tidak ditemukan.',
  'dir.kb.retry': 'Coba lagi',
  'dir.kb.title': 'Basis Pengetahuan',
  'dir.kb.breadcrumb': 'Basis pengetahuan',
  'dir.kb.description': '{articles} artikel di {folders} folder',
  'dir.kb.newArticle': 'Artikel Baru',
  'dir.kb.editArticle': 'Edit Artikel',
  'dir.kb.sectionsAria': 'Bagian basis pengetahuan',
  'dir.kb.tabArticles': 'Artikel',
  'dir.kb.tabStructure': 'Kategori & Folder',
  'dir.kb.folderFilterAria': 'Filter folder',
  'dir.kb.allArticles': 'Semua artikel ({count})',
  'dir.kb.writeFirst': 'Tulis artikel pertama Anda',
  'dir.kb.writeFirstDescription': 'Gunakan Artikel Baru untuk menambahkan konten ke folder ini.',
  'dir.kb.byAuthor': 'oleh {name}',
  'dir.kb.views': '{count} tayangan',
  'dir.kb.published': 'Dipublikasikan',
  'dir.kb.draft': 'Draf',
  'dir.kb.publish': 'Publikasikan',
  'dir.kb.unpublish': 'Batalkan publikasi',
  'dir.kb.noFolders': 'Tidak ada folder dalam kategori ini',
  'dir.kb.noFoldersDescription': 'Tambahkan folder untuk mulai mengelompokkan artikel.',
  'dir.kb.articlesCount': '{count} artikel',
  'dir.kb.fieldTitle': 'Judul',
  'dir.kb.folder': 'Folder',
  'dir.kb.selectFolder': 'Pilih folder',
  'dir.kb.content': 'Konten',
  'dir.kb.contentPlaceholder': 'Tulis konten artikel Anda...',
  'dir.kb.tags': 'Tag (dipisahkan koma)',
  'dir.kb.attachments': 'Lampiran',
  'dir.kb.download': 'Unduh',
  'dir.kb.downloadFile': 'Unduh {name}',
  'dir.kb.remove': 'Hapus',
  'dir.kb.removeFile': 'Hapus {name}',
  'dir.kb.noAttachments': 'Belum ada lampiran.',
  'dir.kb.uploadAria': 'Unggah lampiran',
  'dir.kb.uploading': 'Mengunggah...',
  'dir.kb.addFile': 'Tambah file',
  'dir.kb.confirmDeleteTitle': 'Hapus artikel?',
  'dir.kb.confirmDeleteDescription': 'Artikel yang dipublikasikan atau draf ini akan dihapus secara permanen.',
  'dir.kb.confirmDeleteLabel': 'Hapus artikel',
  'dir.kb.confirmRemoveTitle': 'Hapus lampiran?',
  'dir.kb.confirmRemoveDescription': 'File akan dihapus secara permanen dari artikel ini.',
  'dir.kb.confirmRemoveLabel': 'Hapus lampiran',
  'dir.reports.rangeInvalid': 'Pilih tanggal mulai dan akhir yang valid.',
  'dir.reports.rangeOrder': 'Tanggal akhir harus sama dengan atau setelah tanggal mulai.',
  'dir.reports.rangeMax': 'Laporan mendukung rentang tanggal maksimum 90 hari.',

  'adm.active': 'Aktif',
  'adm.auto.action.add_tag': 'tambah tag',
  'adm.auto.action.assign_agent': 'tugaskan agen',
  'adm.auto.action.assign_group': 'tugaskan grup',
  'adm.auto.action.send_email': 'kirim email',
  'adm.auto.action.send_notification': 'kirim notifikasi',
  'adm.auto.action.set_priority': 'atur prioritas',
  'adm.auto.action.set_status': 'atur status',
  'adm.auto.actions': 'Tindakan',
  'adm.auto.addAction': '+ Tambah tindakan',
  'adm.auto.addCondition': '+ Tambah kondisi',
  'adm.auto.addRule': 'Tambah aturan',
  'adm.auto.colApplied': 'Tindakan diterapkan',
  'adm.auto.colDate': 'Tanggal',
  'adm.auto.colMatched': 'Cocok',
  'adm.auto.colSubject': 'Subjek',
  'adm.auto.colTicket': 'Tiket',
  'adm.auto.conditions': 'Kondisi',
  'adm.auto.confirmDesc': 'Aturan ini akan langsung berhenti berjalan dan tidak dapat dipulihkan.',
  'adm.auto.confirmLabel': 'Hapus aturan',
  'adm.auto.confirmTitle': 'Hapus aturan otomatisasi?',
  'adm.auto.countMany': '{count} aturan otomatisasi',
  'adm.auto.countOne': '{count} aturan otomatisasi',
  'adm.auto.create': 'Buat',
  'adm.auto.createFirst': 'Buat aturan otomatisasi pertama Anda',
  'adm.auto.createFirstDesc': 'Gunakan Tambah aturan untuk merutekan, memprioritaskan, atau memberi notifikasi secara otomatis.',
  'adm.auto.deleteFailed': 'Gagal menghapus',
  'adm.auto.description': 'Aturan dijalankan berurutan sesuai posisi. Kondisi dalam satu aturan digabung dengan AND.',
  'adm.auto.editRule': 'Edit aturan otomatisasi',
  'adm.auto.execFailed': 'Gagal memuat eksekusi',
  'adm.auto.field.assigneeId': 'penerima tugas',
  'adm.auto.field.companyId': 'perusahaan',
  'adm.auto.field.groupId': 'grup',
  'adm.auto.field.priority': 'prioritas',
  'adm.auto.field.requesterId': 'pemohon',
  'adm.auto.field.source': 'sumber',
  'adm.auto.field.status': 'status',
  'adm.auto.field.subject': 'subjek',
  'adm.auto.field.ticketTypeId': 'jenis tiket',
  'adm.auto.hits': 'Pemicuan',
  'adm.auto.loadFailed': 'Gagal memuat aturan otomatisasi',
  'adm.auto.log': 'Log',
  'adm.auto.logTitle': 'Log eksekusi — {name}',
  'adm.auto.moveDown': 'Pindah ke bawah',
  'adm.auto.moveUp': 'Pindah ke atas',
  'adm.auto.newRule': 'Aturan otomatisasi baru',
  'adm.auto.no': 'Tidak',
  'adm.auto.noRuns': 'Belum ada eksekusi tercatat',
  'adm.auto.noRunsDesc': 'Eksekusi akan muncul di sini saat aturan ini pertama kali cocok dengan tiket.',
  'adm.auto.op.contains': 'mengandung',
  'adm.auto.op.ends_with': 'diakhiri dengan',
  'adm.auto.op.greater_than': 'lebih besar dari',
  'adm.auto.op.in': 'dalam',
  'adm.auto.op.is': 'adalah',
  'adm.auto.op.is_empty': 'kosong',
  'adm.auto.op.is_not': 'bukan',
  'adm.auto.op.is_not_empty': 'tidak kosong',
  'adm.auto.op.less_than': 'kurang dari',
  'adm.auto.op.not_contains': 'tidak mengandung',
  'adm.auto.op.not_in': 'tidak dalam',
  'adm.auto.op.starts_with': 'diawali dengan',
  'adm.auto.reorderFailed': 'Gagal mengubah urutan',
  'adm.auto.saveFailed': 'Gagal menyimpan',
  'adm.auto.stopProcessing': 'Hentikan pemrosesan aturan berikutnya',
  'adm.auto.title': 'Aturan otomatisasi',
  'adm.auto.toggleFailed': 'Gagal mengubah status aktif',
  'adm.auto.trigger': 'Pemicu *',
  'adm.auto.trigger.ticket_creation': 'Pembuatan tiket',
  'adm.auto.trigger.ticket_update': 'Pembaruan tiket',
  'adm.auto.trigger.time_trigger': 'Berbasis waktu',
  'adm.auto.triggerCol': 'Pemicu',
  'adm.auto.valuePlaceholder': 'Nilai',
  'adm.auto.yes': 'Ya',
  'adm.close': 'Tutup',
  'adm.deleting': 'Menghapus...',
  'adm.description': 'Deskripsi',
  'adm.descriptionLabel': 'Deskripsi',
  'adm.edit': 'Edit',
  'adm.email.addChannel': 'Tambah saluran',
  'adm.email.addTitle': 'Tambah saluran email',
  'adm.email.colEmail': 'Email',
  'adm.email.colReplyTo': 'Balas ke',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Saluran ini tidak akan lagi tersedia untuk email dukungan.',
  'adm.email.confirmLabel': 'Hapus saluran',
  'adm.email.confirmTitle': 'Hapus saluran email?',
  'adm.email.countMany': '{count} saluran email',
  'adm.email.countOne': '{count} saluran email',
  'adm.email.create': 'Buat',
  'adm.email.createFirst': 'Tambahkan saluran email pertama Anda',
  'adm.email.createFirstDesc': 'Gunakan Tambah saluran untuk menghubungkan alamat dukungan agar balasan sampai ke pusat dukungan ini.',
  'adm.email.default': 'Default',
  'adm.email.defaultChannel': 'Saluran default',
  'adm.email.deleteFailed': 'Gagal menghapus',
  'adm.email.description': 'Kelola alamat email masuk/keluar, konfigurasi SMTP, dan pengaturan balas ke.',
  'adm.email.editTitle': 'Edit saluran email',
  'adm.email.emailAddress': 'Alamat email *',
  'adm.email.loadFailed': 'Gagal memuat konfigurasi email',
  'adm.email.outbound': 'SMTP keluar',
  'adm.email.replyTo': 'Alamat balas ke',
  'adm.email.replyToPh': '(default ke alamat email)',
  'adm.email.saveFailed': 'Gagal menyimpan',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'Host SMTP',
  'adm.email.smtpHostPh': 'mis. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Kata sandi SMTP',
  'adm.email.smtpPort': 'Port SMTP',
  'adm.email.smtpUser': 'Pengguna SMTP',
  'adm.email.title': 'Saluran email',
  'adm.groups.aboutBody': 'Anggota menentukan agen mana yang secara default melihat tiket grup ini. Jam kerja mengatur waktu SLA untuk tiket yang dirutekan ke sini, dan kontak eskalasi diberi notifikasi selain penerima tugas saat tiket melanggar SLA-nya.',
  'adm.groups.aboutTitle': 'Tentang grup ini',
  'adm.groups.accountDefault': 'Default akun',
  'adm.groups.activeAgentMany': '{count} agen aktif',
  'adm.groups.activeAgentOne': '{count} agen aktif',
  'adm.groups.activeAgents': 'Agen aktif',
  'adm.groups.addMember': 'Tambah anggota',
  'adm.groups.assignment': 'Penugasan',
  'adm.groups.autoAssign': 'Penugasan otomatis',
  'adm.groups.autoAssignNote': 'Penugasan tiket selalu manual di produk ini - tidak ada perutean round-robin atau berbasis beban. Sakelar ini tidak mengubah hal tersebut.',
  'adm.groups.businessHours': 'Jam kerja',
  'adm.groups.colGroup': 'Grup',
  'adm.groups.confirmDesc': 'Tiket dan templat yang menggunakan grup ini harus ditugaskan ulang terlebih dahulu.',
  'adm.groups.confirmLabel': 'Hapus grup',
  'adm.groups.confirmTitle': 'Hapus “{name}”?',
  'adm.groups.createFirst': 'Buat grup pertama Anda',
  'adm.groups.defaultHours': 'Jam default',
  'adm.groups.editAria': 'Edit {name}',
  'adm.groups.editGroup': 'Edit Grup',
  'adm.groups.escalateHelp': 'Ditambahkan sebagai penerima notifikasi saat tiket di grup ini melanggar SLA-nya.',
  'adm.groups.escalateTo': 'Eskalasi ke',
  'adm.groups.escalatesTo': 'Dieskalasi ke',
  'adm.groups.escalatesToName': 'Dieskalasi ke {name}',
  'adm.groups.escalationBody': 'Saat tiket di grup ini melanggar SLA-nya, kontak eskalasi ditambahkan sebagai penerima notifikasi bersama penerima tugas dan anggota grup.',
  'adm.groups.escalationTitle': 'Kontak eskalasi',
  'adm.groups.hoursHelp': 'Digunakan untuk perhitungan SLA pada tiket di grup ini.',
  'adm.groups.manageAgents': 'Kelola agen',
  'adm.groups.manageHours': 'Kelola jam kerja',
  'adm.groups.manual': 'Manual',
  'adm.groups.manualBody': 'Penugasan bersifat manual di produk ini - tidak ada penugasan otomatis round-robin atau berbasis beban. Sakelar "Penugasan otomatis" pada grup hanya memengaruhi apakah tiket baru di grup tersebut secara default belum ditugaskan atau mengikuti aturan perutean yang ada; agen tetap mengambil dan menyerahkan tiket sendiri.',
  'adm.groups.manualTitle': 'Penugasan manual',
  'adm.groups.memberMany': '{count} anggota',
  'adm.groups.memberOne': '{count} anggota',
  'adm.groups.members': 'Anggota',
  'adm.groups.newGroup': 'Grup Baru',
  'adm.groups.noEscalation': 'Tanpa kontak eskalasi',
  'adm.groups.noMatch': 'Tidak ada grup yang cocok dengan pencarian ini',
  'adm.groups.noMembers': 'Belum ada anggota',
  'adm.groups.noMembersDesc': 'Pilih agen aktif di atas lalu pilih Tambah anggota.',
  'adm.groups.remove': 'Hapus',
  'adm.groups.routing': 'Perutean',
  'adm.groups.routingMethod': 'Metode perutean',
  'adm.groups.saved': 'Grup disimpan.',
  'adm.groups.searchAria': 'Cari grup',
  'adm.groups.searchPlaceholder': 'Cari berdasarkan nama',
  'adm.groups.selectActiveAgent': 'Pilih agen aktif',
  'adm.groups.showing': 'Menampilkan {start}-{end} dari {total}',
  'adm.groups.subtitle': 'Grup mengatur perutean dan visibilitas tiket. Tugaskan agen sebagai anggota, lalu pilih jadwal jam kerja dan kontak eskalasi untuk setiap grup.',
  'adm.groups.title': 'Grup',
  'adm.groups.tryDifferent': 'Coba nama grup lain.',
  'adm.groups.unassigned': 'Belum ditugaskan',
  'adm.groups.useNew': 'Gunakan Grup Baru untuk merutekan tiket ke sekumpulan agen.',
  'adm.groups.zero': '0 grup',
  'adm.inactive': 'Tidak aktif',
  'adm.jira.accepted': 'Koneksi diterima',
  'adm.jira.accountEmail': 'Email akun Jira',
  'adm.jira.accountEmailLabel': 'Email akun',
  'adm.jira.activeConn': 'Koneksi aktif',
  'adm.jira.addConnection': 'Tambah koneksi',
  'adm.jira.addTitle': 'Tambah koneksi Jira',
  'adm.jira.added': 'Koneksi Jira ditambahkan',
  'adm.jira.apiToken': 'Token API',
  'adm.jira.clearSecret': 'Hapus rahasia webhook yang tersimpan',
  'adm.jira.confirmDesc': 'Ini menghapus koneksi tersimpan beserta tautan tiketnya. Isu Jira tidak dihapus.',
  'adm.jira.confirmLabel': 'Hapus koneksi',
  'adm.jira.confirmTitle': 'Hapus {name}?',
  'adm.jira.connName': 'Nama koneksi',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Terhubung sebagai {name}',
  'adm.jira.connectionDesk': 'Meja koneksi',
  'adm.jira.default': 'Default',
  'adm.jira.defaultConn': 'Koneksi default',
  'adm.jira.defaultIssueType': 'Jenis isu default',
  'adm.jira.defaultProjectKey': 'Kunci proyek default',
  'adm.jira.defaults': 'Default',
  'adm.jira.description': 'Hubungkan situs Jira milik akun agar agen dapat menautkan isu dan menjaga status tiket tetap selaras.',
  'adm.jira.editTitle': 'Edit koneksi Jira',
  'adm.jira.footer': 'Buat webhook Jira dengan endpoint yang ditampilkan di atas, berlangganan peristiwa isu diperbarui, dan gunakan rahasia webhook yang sama dengan yang dikonfigurasi di sini.',
  'adm.jira.heading': 'Jaga dukungan dan rekayasa tetap dalam satu alur',
  'adm.jira.intro': 'Kredensial disimpan terenkripsi di server dan tidak pernah dikembalikan ke layar ini. Konfigurasikan rahasia webhook agar Jira dapat mengirim perubahan status kembali ke SuzukiDesk.',
  'adm.jira.no': 'Tidak',
  'adm.jira.noConns': 'Belum ada koneksi Jira',
  'adm.jira.noConnsDesc': 'Tambahkan koneksi agar tindakan Jira tersedia dari detail tiket.',
  'adm.jira.noProject': 'Tanpa proyek',
  'adm.jira.pasteToken': 'Tempel token',
  'adm.jira.requestFailed': 'Permintaan Jira gagal. Silakan coba lagi.',
  'adm.jira.savedToast': 'Koneksi Jira disimpan',
  'adm.jira.secretConfigured': 'Rahasia dikonfigurasi: {value}',
  'adm.jira.secretHint': 'Gunakan rahasia yang sama saat membuat webhook Jira.',
  'adm.jira.secretOptional': 'Opsional, 16+ karakter',
  'adm.jira.siteUrl': 'URL situs Jira',
  'adm.jira.siteUrlHint': 'Jangan sertakan kredensial dalam URL.',
  'adm.jira.syncFromJira': 'Status Jira kembali ke tiket',
  'adm.jira.syncSnapshot': 'Cuplikan isu tertaut',
  'adm.jira.syncToJira': 'Status tiket ke Jira',
  'adm.jira.testConnection': 'Uji koneksi',
  'adm.jira.testFailed': 'Uji koneksi gagal',
  'adm.jira.title': 'Integrasi Jira',
  'adm.jira.tokenHintEdit': 'Biarkan kosong untuk mempertahankan token saat ini.',
  'adm.jira.tokenHintNew': 'Disimpan terenkripsi; tidak akan ditampilkan lagi.',
  'adm.jira.tokenMissing': 'Token API tidak ada',
  'adm.jira.tokenStored': 'Token API tersimpan',
  'adm.jira.unchanged': '(tidak berubah jika kosong)',
  'adm.jira.verified': 'Koneksi Jira terverifikasi',
  'adm.jira.webhookEndpoint': 'Endpoint webhook Jira',
  'adm.jira.webhookSecret': 'Rahasia webhook',
  'adm.jira.whatSyncs': 'Yang disinkronkan',
  'adm.jira.yes': 'Ya',
  'adm.nameRequired': 'Nama *',
  'adm.nextPage': 'Halaman berikutnya',
  'adm.notif.aud.all': 'Bersama',
  'adm.notif.aud.customer': 'Pelanggan',
  'adm.notif.aud.internal': 'Internal',
  'adm.notif.audEmail': 'Email {audience}',
  'adm.notif.body': 'Isi',
  'adm.notif.description': 'Sesuaikan setiap audiens notifikasi tanpa mengarahkan pelanggan ke ruang kerja internal.',
  'adm.notif.discardDesc': 'Perubahan yang belum disimpan pada templat notifikasi ini akan hilang jika Anda berpindah templat.',
  'adm.notif.discardLabel': 'Buang perubahan',
  'adm.notif.discardTitle': 'Buang perubahan yang belum disimpan?',
  'adm.notif.discarded': 'Perubahan yang belum disimpan dibuang.',
  'adm.notif.event.automation_notification': 'Notifikasi otomatisasi',
  'adm.notif.event.group_member_added': 'Ditambahkan ke grup',
  'adm.notif.event.mention': 'Sebutan',
  'adm.notif.event.pending_input': 'Menunggu masukan',
  'adm.notif.event.sla_breach': 'Pelanggaran SLA',
  'adm.notif.event.sla_escalation': 'Eskalasi SLA',
  'adm.notif.event.sla_warning': 'Peringatan SLA',
  'adm.notif.event.ticket_assigned': 'Tiket ditugaskan',
  'adm.notif.event.ticket_created': 'Tiket dibuat',
  'adm.notif.event.ticket_first_response': 'Respons pertama',
  'adm.notif.event.ticket_group_assigned': 'Tiket ditugaskan ke grup',
  'adm.notif.event.ticket_note': 'Catatan privat',
  'adm.notif.event.ticket_public_note': 'Catatan publik',
  'adm.notif.event.ticket_reply': 'Balasan tiket',
  'adm.notif.event.ticket_resolved': 'Tiket terselesaikan',
  'adm.notif.events': 'Peristiwa',
  'adm.notif.eventsHelp': 'Pilih peristiwa dan audiens penerima.',
  'adm.notif.insertVar': 'Sisipkan {variable}',
  'adm.notif.linkNoteAgent': 'Variabel tautan sesuai audiens {variable} membuka ruang kerja agen untuk email ini.',
  'adm.notif.linkNoteCustomer': 'Variabel tautan sesuai audiens {variable} membuka portal pelanggan untuk email ini.',
  'adm.notif.off': 'nonaktif',
  'adm.notif.preview': 'Pratinjau',
  'adm.notif.previewNotice': 'Pratinjau dirender dengan data contoh.',
  'adm.notif.rendering': 'Merender…',
  'adm.notif.route.all': 'Menggunakan tautan tiket sesuai penerima untuk audiens pengiriman.',
  'adm.notif.route.customer': 'Tindakan utama membuka tiket di portal pelanggan.',
  'adm.notif.route.internal': 'Tindakan utama membuka tiket di ruang kerja agen.',
  'adm.notif.sampleOnlyAgent': 'Hanya data contoh — tindakan utama mengarah ke rute ruang kerja agen.',
  'adm.notif.sampleOnlyCustomer': 'Hanya data contoh — tindakan utama mengarah ke rute portal pelanggan.',
  'adm.notif.saveChanges': 'Simpan perubahan',
  'adm.notif.saved': 'Templat disimpan.',
  'adm.notif.savedBtn': 'Tersimpan',
  'adm.notif.selectEvent': 'Pilih peristiwa untuk mengedit templatnya',
  'adm.notif.selectEventDesc': 'Pilih peristiwa notifikasi di sebelah kiri untuk mengubah subjek dan isinya.',
  'adm.notif.sendTest': 'Kirim email uji coba',
  'adm.notif.sending': 'Mengirim…',
  'adm.notif.subject': 'Subjek',
  'adm.notif.testQueued': 'Email uji coba diantrekan ke {email}.',
  'adm.notif.title': 'Templat notifikasi',
  'adm.notif.urlVarTitle': 'Variabel tautan sesuai audiens',
  'adm.notif.useTemplate': 'Gunakan templat ini untuk audiens ini',
  'adm.notif.useTemplateHelp': 'Jika dinonaktifkan, notifikasi cadangan yang aman akan digunakan.',
  'adm.notif.variables': 'Variabel',
  'adm.notif.variablesHelp': 'Klik untuk menambahkan ke isi pesan',
  'adm.pagination': 'Paginasi',
  'adm.perm.cap.admin.label': 'Mengakses konsol administrasi',
  'adm.perm.cap.assign.label': 'Menugaskan tiket',
  'adm.perm.cap.close.label': 'Menutup tiket',
  'adm.perm.cap.conversation_delete.label': 'Menghapus balasan atau catatan yang telah diposting',
  'adm.perm.cap.conversation_edit.label': 'Mengedit balasan atau catatan yang telah diposting',
  'adm.perm.cap.create.label': 'Membuat tiket',
  'adm.perm.cap.delete.label': 'Menghapus tiket',
  'adm.perm.cap.edit.label': 'Mengedit properti tiket',
  'adm.perm.cap.export.label': 'Mengekspor tiket',
  'adm.perm.cap.field_admin.label': 'Kolom tiket',
  'adm.perm.cap.form_admin.label': 'Formulir tiket',
  'adm.perm.cap.forward.label': 'Meneruskan tiket',
  'adm.perm.cap.jira_link.label': 'Menautkan dan mengelola isu Jira',
  'adm.perm.cap.kb.label': 'Mengakses basis pengetahuan',
  'adm.perm.cap.manage_agents.label': 'Agen',
  'adm.perm.cap.manage_api_keys.label': 'Kunci API',
  'adm.perm.cap.manage_automations.label': 'Otomatisasi',
  'adm.perm.cap.manage_canned_responses.label': 'Respons tersimpan',
  'adm.perm.cap.manage_email_config.label': 'Email',
  'adm.perm.cap.manage_groups.label': 'Grup',
  'adm.perm.cap.manage_jira.label': 'Integrasi Jira',
  'adm.perm.cap.manage_kb.label': 'Basis pengetahuan',
  'adm.perm.cap.manage_notification_templates.label': 'Templat notifikasi',
  'adm.perm.cap.manage_roles.label': 'Peran',
  'adm.perm.cap.manage_tags.label': 'Tag',
  'adm.perm.cap.note.label': 'Menambah atau mengedit catatan privat',
  'adm.perm.cap.reassign.label': 'Menugaskan ulang tiket yang sudah dimiliki orang lain',
  'adm.perm.cap.reopen.label': 'Membuka kembali tiket yang terselesaikan atau ditutup',
  'adm.perm.cap.reply.label': 'Membalas pelanggan secara publik',
  'adm.perm.cap.report_access.label': 'Melihat laporan dan dasbor',
  'adm.perm.cap.reports.label': 'Mengakses modul pelaporan',
  'adm.perm.cap.resolve.label': 'Menyelesaikan tiket',
  'adm.perm.cap.settings_admin.label': 'Membuka bagian Pengaturan (diperlukan untuk melihat item navigasi Pengaturan dan halaman indeksnya; akses ke setiap halaman di bawah tetap dikontrol secara terpisah)',
  'adm.perm.cap.sla_admin.label': 'Kebijakan SLA & jam kerja',
  'adm.perm.cap.sla_edit.desc': 'Terpisah dari izin Pengaturan > Kebijakan SLA di bawah — ini hanya mencakup pengeditan tanggal jatuh tempo pada satu tiket.',
  'adm.perm.cap.sla_edit.label': 'Menimpa tanggal jatuh tempo SLA tiket secara manual',
  'adm.perm.cap.tag.label': 'Mengelola tag tiket',
  'adm.perm.cap.thread_start.label': 'Memulai utas privat pada entri percakapan',
  'adm.perm.cap.tickets.label': 'Mengakses ruang kerja tiket',
  'adm.perm.cap.view.label': 'Melihat tiket dalam cakupan',
  'adm.perm.cat.administration.desc': 'Akses ke konsol admin dan layar konfigurasinya.',
  'adm.perm.cat.administration.label': 'Administrasi',
  'adm.perm.cat.knowledge.desc': 'Membaca dan menggunakan konten pengetahuan saat menangani tiket.',
  'adm.perm.cat.knowledge.label': 'Basis pengetahuan',
  'adm.perm.cat.reporting.desc': 'Pelaporan operasional dan dasbor.',
  'adm.perm.cat.reporting.label': 'Pelaporan',
  'adm.perm.cat.settings-pages.desc': 'Berikan akses ke setiap layar Pengaturan secara terpisah. Tidak ada yang terlihat sampai dicentang secara eksplisit di sini.',
  'adm.perm.cat.settings-pages.label': 'Halaman pengaturan',
  'adm.perm.cat.tickets.desc': 'Apa yang dapat dilakukan agen di dalam ruang kerja tiket.',
  'adm.perm.cat.tickets.label': 'Tiket',
  'adm.previousPage': 'Halaman sebelumnya',
  'adm.refresh': 'Segarkan',
  'adm.roleType.administrator': 'Administrator',
  'adm.roleType.agent': 'Agen',
  'adm.roleType.collaborator': 'Kolaborator',
  'adm.roleType.customer': 'Pelanggan',
  'adm.roleType.super_admin': 'Super admin',
  'adm.roleType.supervisor': 'Supervisor',
  'adm.roles.activeHelp': 'Aktif - peran tidak aktif tidak dapat ditetapkan ke agen',
  'adm.roles.agentCan': 'Agen dapat',
  'adm.roles.agentType': 'Jenis Agen',
  'adm.roles.agentsAssignedNote': 'Agen ditetapkan ke peran ini dari layar Agen.',
  'adm.roles.agentsCount': '{count} Agen',
  'adm.roles.agentsLabel': 'Agen',
  'adm.roles.agentsManage': '{count} Agen - Kelola',
  'adm.roles.builtIn': '(Bawaan)',
  'adm.roles.builtInNote': 'Ini adalah peran bawaan. Peran ini dapat diganti namanya dan dinonaktifkan, tetapi tidak dapat dihapus.',
  'adm.roles.builtInTitle': 'Peran bawaan: dapat diedit dan dinonaktifkan, tetapi tidak dapat dihapus',
  'adm.roles.categoriesAria': 'Kategori izin',
  'adm.roles.confirmDesc': 'Agen yang ditetapkan ke peran ini memerlukan peran lain sebelum peran ini dapat dihapus.',
  'adm.roles.confirmLabel': 'Hapus peran',
  'adm.roles.createFirst': 'Buat peran pertama Anda',
  'adm.roles.createFirstDesc': 'Gunakan Peran Baru untuk menentukan kemampuan yang akan dimiliki agen.',
  'adm.roles.editRole': 'Edit Peran',
  'adm.roles.granted': '{count} diberikan',
  'adm.roles.heading': 'Peran Agen',
  'adm.roles.inactive': 'Tidak aktif',
  'adm.roles.newRole': 'Peran Baru',
  'adm.roles.noAgent': 'Tanpa Agen',
  'adm.roles.notEnforced': '(belum diberlakukan)',
  'adm.roles.notEnforcedTitle': 'Tersimpan pada peran tetapi belum dibatasi di mana pun saat runtime',
  'adm.roles.permissions': 'Izin',
  'adm.roles.saved': 'Peran disimpan.',
  'adm.roles.scopeBody': 'Kemampuan digabungkan dengan cakupan tingkat baris (semua / grup / ditugaskan / milik sendiri), sehingga agen hanya bertindak pada tiket yang sudah dapat mereka lihat.',
  'adm.roles.scopeTitle': 'Cakupan tetap berlaku',
  'adm.roles.scrollTo': 'Gulir ke',
  'adm.roles.status': 'Status',
  'adm.roles.subtitle': 'Berikan dan batasi tingkat akses dan hak istimewa yang terperinci untuk agen.',
  'adm.roles.title': 'Peran',
  'adm.roles.typeLocked': 'Jenis agen tidak dapat diubah setelah peran disimpan.',
  'adm.roles.understandingBody1': 'Peran menentukan apa yang dapat dilakukan agen. Buat peran, centang kemampuan yang harus diberikan, lalu tetapkan ke agen dari layar Agen.',
  'adm.roles.understandingBody2': 'Peran bawaan dapat diganti namanya dan dinonaktifkan tetapi tidak pernah dihapus. Peran yang masih memiliki agen juga tidak dapat dihapus, jadi pindahkan agen tersebut terlebih dahulu.',
  'adm.roles.understandingTitle': 'Memahami Peran',
  'adm.saveChanges': 'Simpan perubahan',
  'adm.settings.add': 'Tambah {name}',
  'adm.settings.back': 'Kembali ke pengaturan',
  'adm.settings.cannedDesc': 'Respons akun yang tersedia untuk Anda saat menangani tiket.',
  'adm.settings.cannedEmpty': 'Belum ada respons tersimpan',
  'adm.settings.cannedEmptyDesc': 'Minta administrator menambahkan respons bersama yang dapat digunakan ulang tim Anda pada tiket.',
  'adm.settings.cannedTitle': 'Respons tersimpan',
  'adm.settings.col.autoAssign': 'Penugasan Otomatis',
  'adm.settings.col.color': 'Warna',
  'adm.settings.col.content': 'Konten',
  'adm.settings.col.createdAt': 'Dibuat Pada',
  'adm.settings.col.description': 'Deskripsi',
  'adm.settings.col.email': 'Email',
  'adm.settings.col.expiresAt': 'Kedaluwarsa Pada',
  'adm.settings.col.fieldType': 'Jenis Kolom',
  'adm.settings.col.firstName': 'Nama Depan',
  'adm.settings.col.folderId': 'ID Folder',
  'adm.settings.col.hitCount': 'Jumlah Pemicuan',
  'adm.settings.col.holidays': 'Hari Libur',
  'adm.settings.col.host': 'Host',
  'adm.settings.col.hours': 'Jam',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Aktif',
  'adm.settings.col.isBuiltIn': 'Bawaan',
  'adm.settings.col.isDefault': 'Default',
  'adm.settings.col.isRequired': 'Wajib',
  'adm.settings.col.isShared': 'Dibagikan',
  'adm.settings.col.isSystem': 'Sistem',
  'adm.settings.col.key': 'Kunci',
  'adm.settings.col.label': 'Label',
  'adm.settings.col.language': 'Bahasa',
  'adm.settings.col.lastName': 'Nama Belakang',
  'adm.settings.col.lastUsedAt': 'Terakhir Digunakan',
  'adm.settings.col.name': 'Nama',
  'adm.settings.col.options': 'Opsi',
  'adm.settings.col.phone': 'Telepon',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Posisi',
  'adm.settings.col.prefix': 'Awalan',
  'adm.settings.col.priority': 'Prioritas',
  'adm.settings.col.required': 'Wajib',
  'adm.settings.col.role': 'Peran',
  'adm.settings.col.roleId': 'ID Peran',
  'adm.settings.col.scopes': 'Cakupan',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Status',
  'adm.settings.col.stopProcessing': 'Hentikan Pemrosesan',
  'adm.settings.col.timezone': 'Zona Waktu',
  'adm.settings.col.title': 'Judul',
  'adm.settings.col.trigger': 'Pemicu',
  'adm.settings.col.type': 'Jenis',
  'adm.settings.col.updatedAt': 'Diperbarui Pada',
  'adm.settings.col.usageCount': 'Jumlah Penggunaan',
  'adm.settings.col.username': 'Nama Pengguna',
  'adm.settings.confirmDesc': 'Tindakan ini tidak dapat dibatalkan.',
  'adm.settings.confirmTitle': 'Hapus {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Buat',
  'adm.settings.empty': 'Belum ada {title}',
  'adm.settings.emptyAdd': 'Gunakan formulir di atas untuk menambahkan {name} pertama Anda.',
  'adm.settings.emptyOther': 'Entri akan muncul di sini setelah dikonfigurasi.',
  'adm.settings.homeDesc': 'Konfigurasikan pengguna, alur kerja tiket, tingkat layanan, dan integrasi.',
  'adm.settings.manage': 'Kelola {title}.',
  'adm.settings.noPages': 'Tidak ada halaman pengaturan yang tersedia',
  'adm.settings.noPagesDesc': 'Minta super admin untuk memberikan akses ke halaman pengaturan yang Anda perlukan.',
  'adm.settings.notFound': 'Halaman pengaturan tidak ditemukan',
  'adm.settings.notFoundDesc': 'Pilih area pengaturan untuk melanjutkan.',
  'adm.settings.res.agents.field.email': 'Email',
  'adm.settings.res.agents.field.firstName': 'Nama depan',
  'adm.settings.res.agents.field.lastName': 'Nama belakang',
  'adm.settings.res.agents.field.password': 'Kata sandi sementara',
  'adm.settings.res.agents.field.roleId': 'ID Peran',
  'adm.settings.res.agents.one': 'agen',
  'adm.settings.res.agents.title': 'Agen',
  'adm.settings.res.api-keys.field.name': 'Nama kunci',
  'adm.settings.res.api-keys.one': 'kunci API',
  'adm.settings.res.api-keys.title': 'Kunci API',
  'adm.settings.res.automations.field.description': 'Deskripsi',
  'adm.settings.res.automations.field.name': 'Nama',
  'adm.settings.res.automations.one': 'otomatisasi',
  'adm.settings.res.automations.title': 'Otomatisasi',
  'adm.settings.res.business-hours.field.name': 'Nama',
  'adm.settings.res.business-hours.field.timezone': 'Zona waktu',
  'adm.settings.res.business-hours.one': 'entri jam kerja',
  'adm.settings.res.business-hours.title': 'Jam kerja',
  'adm.settings.res.canned-responses.field.content': 'Konten respons',
  'adm.settings.res.canned-responses.field.title': 'Judul',
  'adm.settings.res.canned-responses.one': 'respons tersimpan',
  'adm.settings.res.canned-responses.title': 'Respons tersimpan',
  'adm.settings.res.email.field.host': 'Host SMTP',
  'adm.settings.res.email.field.name': 'Nama',
  'adm.settings.res.email.field.port': 'Port SMTP',
  'adm.settings.res.email.field.username': 'Nama pengguna',
  'adm.settings.res.email.one': 'konfigurasi email',
  'adm.settings.res.email.title': 'Konfigurasi email',
  'adm.settings.res.fields.one': 'kolom tiket',
  'adm.settings.res.fields.title': 'Kolom tiket',
  'adm.settings.res.forms.field.label': 'Label tampilan',
  'adm.settings.res.forms.field.name': 'Nama kolom',
  'adm.settings.res.forms.field.type': 'Jenis kolom',
  'adm.settings.res.forms.one': 'formulir atau kolom kustom',
  'adm.settings.res.forms.title': 'Formulir dan kolom kustom',
  'adm.settings.res.groups.field.description': 'Deskripsi',
  'adm.settings.res.groups.field.name': 'Nama',
  'adm.settings.res.groups.one': 'grup',
  'adm.settings.res.groups.title': 'Grup',
  'adm.settings.res.jira.one': 'integrasi Jira',
  'adm.settings.res.jira.title': 'Integrasi Jira',
  'adm.settings.res.kb.field.content': 'Konten artikel',
  'adm.settings.res.kb.field.folderId': 'ID Folder',
  'adm.settings.res.kb.field.title': 'Judul artikel',
  'adm.settings.res.kb.one': 'artikel basis pengetahuan',
  'adm.settings.res.kb.title': 'Administrasi basis pengetahuan',
  'adm.settings.res.notification-templates.one': 'templat notifikasi',
  'adm.settings.res.notification-templates.title': 'Templat notifikasi',
  'adm.settings.res.roles.field.description': 'Deskripsi',
  'adm.settings.res.roles.field.name': 'Nama',
  'adm.settings.res.roles.field.type': 'Jenis peran',
  'adm.settings.res.roles.one': 'peran',
  'adm.settings.res.roles.title': 'Peran',
  'adm.settings.res.sla.field.description': 'Deskripsi',
  'adm.settings.res.sla.field.name': 'Nama',
  'adm.settings.res.sla.one': 'kebijakan SLA',
  'adm.settings.res.sla.title': 'Kebijakan SLA',
  'adm.settings.res.tags.field.name': 'Nama',
  'adm.settings.res.tags.one': 'tag',
  'adm.settings.res.tags.title': 'Tag',
  'adm.settings.title': 'Pengaturan',
  'adm.status': 'Status',

  'sla.edit': 'Edit',
  'sla.active': 'Aktif',
  'sla.inactive': 'Tidak aktif',
  'sla.default': 'Default',
  'sla.yes': 'Ya',
  'sla.no': 'Tidak',
  'sla.description': 'Deskripsi',
  'sla.status': 'Status',
  'sla.notConfigured': 'Belum dikonfigurasi',
  'sla.minutesValue': '{value} menit',
  'sla.invalidServerValue': 'Nilai server tidak valid',
  'sla.statusSemantics.title': 'Semantik status tiket',
  'sla.statusSemantics.description': 'Setiap status aktif memiliki kontrak SLA yang eksplisit. Status yang menjeda dan status yang menghentikan SLA saling eksklusif.',
  'sla.statusSemantics.conflict': 'Sebuah status tidak dapat menjeda SLA dan menghentikan SLA secara bersamaan.',
  'sla.statusSemantics.emptyTitle': 'Tidak ada definisi status',
  'sla.statusSemantics.emptyDescription': 'Definisi status akan muncul di sini setelah dikonfigurasi untuk akun ini.',
  'sla.statusSemantics.colPauses': 'Menjeda SLA',
  'sla.statusSemantics.colStops': 'Menghentikan SLA',
  'sla.statusSemantics.pausesAria': '{label} menjeda SLA',
  'sla.statusSemantics.stopsAria': '{label} menghentikan SLA',
  'sla.preview.title': 'Pratinjau tiket hanya-baca',
  'sla.preview.description': 'Jalankan evaluator tingkat akun yang sama dengan yang digunakan siklus SLA aktif. Pratinjau ini tidak pernah menulis kebijakan atau tiket.',
  'sla.preview.priority': 'Prioritas',
  'sla.preview.group': 'Grup',
  'sla.preview.anyGroup': 'Grup apa pun',
  'sla.preview.company': 'Perusahaan',
  'sla.preview.anyCompany': 'Perusahaan apa pun',
  'sla.preview.source': 'Sumber',
  'sla.preview.anySource': 'Sumber apa pun',
  'sla.preview.ticketType': 'Jenis tiket',
  'sla.preview.anyTicketType': 'Jenis tiket apa pun',
  'sla.preview.representativeStart': 'Waktu mulai representatif',
  'sla.preview.calculating': 'Menghitung…',
  'sla.preview.run': 'Jalankan pratinjau',
  'sla.preview.configAttention': 'Konfigurasi perlu diperhatikan',
  'sla.preview.selectedPolicy': 'Kebijakan terpilih',
  'sla.preview.noPolicy': 'Tanpa kebijakan',
  'sla.preview.evaluationOrder': 'Urutan evaluasi',
  'sla.preview.firstMatching': 'Kebijakan pertama yang cocok',
  'sla.preview.calculationMode': 'Mode perhitungan',
  'sla.preview.modeBusinessHours': 'Jam kerja',
  'sla.preview.modeBusinessHoursNamed': 'Jam kerja · {name}',
  'sla.preview.mode247': 'Waktu berlalu 24/7',
  'sla.preview.modeNone': 'Tidak dihitung',
  'sla.preview.thresholds': 'Ambang batas independen',
  'sla.preview.colMetric': 'Metrik',
  'sla.preview.colTarget': 'Target',
  'sla.preview.colWarning': 'Peringatan',
  'sla.preview.colDue': 'Jatuh tempo / pelanggaran',
  'sla.preview.colEscalation': 'Eskalasi',
  'sla.preview.colState': 'Status',
  'sla.preview.metricFirstResponse': 'Respons pertama',
  'sla.preview.metricResolution': 'Penyelesaian',
  'sla.preview.trace': 'Jejak evaluasi kebijakan',
  'sla.preview.selected': 'Terpilih',
  'sla.preview.matchedAfterSelection': 'Cocok setelah pemilihan',
  'sla.preview.skipped': 'Dilewati',
  'sla.preview.showTrace': 'Tampilkan jejak perhitungan',
  'sla.state.not_configured': 'belum dikonfigurasi',
  'sla.state.running': 'berjalan',
  'sla.state.paused': 'dijeda',
  'sla.state.warning': 'peringatan',
  'sla.state.breached': 'dilanggar',
  'sla.state.met': 'terpenuhi',
  'sla.state.escalated': 'dieskalasi',
  'sla.state.pending': 'tertunda',
  'sla.state.stopped': 'dihentikan',
  'sla.state.on_track': 'sesuai jalur',
  'sla.state.at_risk': 'berisiko',
  'sla.list.subtitle': 'Tetapkan target respons pertama dan penyelesaian per prioritas. Kebijakan dievaluasi dari atas ke bawah — yang pertama kondisinya cocok dengan tiket akan dipakai.',
  'sla.list.newPolicy': 'Kebijakan Baru',
  'sla.list.emptyTitle': 'Buat kebijakan SLA pertama Anda',
  'sla.list.emptyDescription': 'Gunakan Kebijakan Baru untuk menetapkan target respons pertama dan penyelesaian per prioritas.',
  'sla.list.moveUp': 'Pindah ke atas',
  'sla.list.moveDown': 'Pindah ke bawah',
  'sla.list.frShort': 'RP: {value}',
  'sla.list.resolveShort': 'Selesai: {value}',
  'sla.list.escalateShort': 'Eskalasi: +{value}',
  'sla.list.deactivate': 'Nonaktifkan',
  'sla.list.activate': 'Aktifkan',
  'sla.list.setDefault': 'Jadikan Default',
  'sla.list.duplicate': 'Duplikat',
  'sla.list.deleteTitle': 'Hapus “{name}”?',
  'sla.list.deleteDescription': 'Tiket yang cocok dengan kebijakan ini akan menggunakan kebijakan SLA berikutnya yang tersedia.',
  'sla.list.deleteConfirm': 'Hapus kebijakan',
  'sla.conditions.groups': '{count} grup',
  'sla.conditions.companies': '{count} perusahaan',
  'sla.conditions.sources': 'sumber: {list}',
  'sla.conditions.ticketTypes': '{count} jenis tiket',
  'sla.conditions.anyOf': 'salah satu dari',
  'sla.conditions.allOf': 'semua dari',
  'sla.conditions.summary': 'Kondisi ({mode}): {parts}',
  'sla.edit.newTitle': 'Kebijakan SLA Baru',
  'sla.edit.editTitle': 'Edit Kebijakan SLA',
  'sla.edit.saved': 'Kebijakan SLA disimpan.',
  'sla.edit.name': 'Nama',
  'sla.edit.appliesToPriority': 'Berlaku untuk prioritas',
  'sla.edit.evaluationOrder': 'Urutan evaluasi',
  'sla.edit.evaluationOrderHint': 'Posisi yang lebih rendah dievaluasi lebih dahulu untuk akun ini.',
  'sla.edit.defaultPolicy': 'Kebijakan default',
  'sla.edit.useAsDefault': 'Gunakan sebagai default bila tidak ada kebijakan lain yang cocok',
  'sla.edit.targets': 'Target SLA',
  'sla.edit.firstResponse': 'Respons pertama',
  'sla.edit.resolution': 'Penyelesaian',
  'sla.edit.autoAt75': 'Otomatis pada 75%',
  'sla.edit.enabledAfter': 'Diaktifkan setelah {value}',
  'sla.edit.clearEscalation': 'Hapus target eskalasi secara eksplisit',
  'sla.edit.clearEscalationHint': 'Mengirim null; jika tidak dicentang, kolom dihilangkan dan nilai tersimpan dipertahankan.',
  'sla.edit.firstResponseMinutes': 'Respons pertama (menit)',
  'sla.edit.resolutionMinutes': 'Penyelesaian (menit)',
  'sla.edit.escalateAfter': 'Eskalasi setelah (menit melewati jatuh tempo penyelesaian)',
  'sla.edit.notSet': 'Belum diatur',
  'sla.edit.remindersNote': 'Pengingat berjalan otomatis pada 75% dari jendela respons pertama dan penyelesaian. Eskalasi memberi notifikasi kepada agen eskalasi grup tiket (diatur pada grup) setelah target penyelesaian terlewat sejumlah menit yang dikonfigurasi.',
  'sla.edit.conditions': 'Kondisi',
  'sla.edit.conditionsHint': 'Biarkan grup tidak dicentang untuk mencocokkan semua nilai',
  'sla.edit.matchMode': 'Mode pencocokan:',
  'sla.edit.matchAll': 'Cocokkan SEMUA kondisi',
  'sla.edit.matchAny': 'Cocokkan SALAH SATU kondisi',
  'sla.edit.groups': 'Grup',
  'sla.edit.companies': 'Perusahaan',
  'sla.edit.sources': 'Sumber',
  'sla.edit.ticketTypes': 'Jenis Tiket',
  'sla.bh.subtitle': 'Tentukan jadwal mingguan dan kalender hari libur yang digunakan kebijakan SLA untuk menghitung tanggal jatuh tempo.',
  'sla.bh.newCalendar': 'Kalender Baru',
  'sla.bh.emptyTitle': 'Buat kalender jam kerja pertama Anda',
  'sla.bh.emptyDescription': 'Gunakan Kalender Baru untuk menentukan jadwal mingguan yang dihitung oleh kebijakan SLA.',
  'sla.bh.accountDefault': 'Default akun',
  'sla.bh.closedEveryDay': 'Tutup setiap hari',
  'sla.bh.openEveryDay': 'Buka setiap hari',
  'sla.bh.openDaysOne': 'Buka 1 hari/minggu',
  'sla.bh.openDaysMany': 'Buka {count} hari/minggu',
  'sla.bh.holidayOne': '1 hari libur',
  'sla.bh.holidayMany': '{count} hari libur',
  'sla.bh.deleteTitle': 'Hapus “{name}”?',
  'sla.bh.deleteDescription': 'Kebijakan SLA dan grup yang menggunakan jadwal ini akan kembali ke default akun.',
  'sla.bh.deleteConfirm': 'Hapus jadwal',
  'sla.bh.newTitle': 'Kalender Jam Kerja Baru',
  'sla.bh.editTitle': 'Edit Jam Kerja',
  'sla.bh.saved': 'Jam kerja disimpan.',
  'sla.bh.timezone': 'Zona waktu',
  'sla.bh.defaultCalendar': 'Kalender default',
  'sla.bh.useAsDefault': 'Gunakan untuk kebijakan SLA dan grup yang tidak menentukan kalender sendiri',
  'sla.bh.weeklySchedule': 'Jadwal mingguan',
  'sla.bh.colDay': 'Hari',
  'sla.bh.colOpen': 'Buka',
  'sla.bh.colStart': 'Mulai',
  'sla.bh.colEnd': 'Selesai',
  'sla.bh.dayOpenAria': '{day} buka',
  'sla.bh.dayStartAria': 'Waktu mulai {day}',
  'sla.bh.dayEndAria': 'Waktu selesai {day}',
  'sla.bh.holidayCalendar': 'Kalender hari libur',
  'sla.bh.saveFirst': 'Simpan kalender ini terlebih dahulu, lalu tambahkan hari libur.',
  'sla.bh.holidayName': 'Nama hari libur',
  'sla.bh.date': 'Tanggal',
  'sla.bh.addHoliday': 'Tambah hari libur',
  'sla.bh.noHolidays': 'Belum ada hari libur',
  'sla.bh.noHolidaysHint': 'Tambahkan hari libur bertanggal di atas agar dikecualikan dari perhitungan SLA.',
  'sla.bh.remove': 'Hapus',
  'sla.day.monday': 'Senin',
  'sla.day.tuesday': 'Selasa',
  'sla.day.wednesday': 'Rabu',
  'sla.day.thursday': 'Kamis',
  'sla.day.friday': 'Jumat',
  'sla.day.saturday': 'Sabtu',
  'sla.day.sunday': 'Minggu',

  'set.ftype.single_line_text': 'Teks satu baris',
  'set.ftype.multi_line_text': 'Teks multi-baris',
  'set.ftype.dropdown': 'Dropdown',
  'set.ftype.checkbox': 'Kotak centang',
  'set.ftype.radio': 'Radio',
  'set.ftype.multiselect': 'Pilihan ganda',
  'set.ftype.lookup': 'Relasi pencarian',
  'set.ftype.dependent': 'Kolom dependen',
  'set.ftype.date': 'Tanggal',
  'set.ftype.number': 'Angka',
  'set.ftype.decimal': 'Desimal',
  'set.ftype.desc.lookup': 'Pilih catatan dari sumber sistem.',
  'set.ftype.desc.single_line_text': 'Nilai teks pendek.',
  'set.ftype.desc.multi_line_text': 'Nilai teks panjang.',
  'set.ftype.desc.checkbox': 'Nilai benar atau salah.',
  'set.ftype.desc.dropdown': 'Pilih satu opsi yang dinormalisasi.',
  'set.ftype.desc.dependent': 'Opsi bergantung pada kolom induk.',
  'set.ftype.desc.date': 'Nilai tanggal kalender.',
  'set.ftype.desc.number': 'Nilai bilangan bulat.',
  'set.ftype.desc.decimal': 'Nilai bilangan desimal.',
  'set.src.STATIC': 'Opsi statis',
  'set.src.AGENTS': 'Agen',
  'set.src.USERS': 'Pengguna / Pelanggan',
  'set.src.GROUPS': 'Grup',
  'set.src.ROLE': 'Peran',
  'set.src.COUNTRIES': 'Negara',
  'set.src.CUSTOM': 'Daftar dropdown kustom',
  'set.settings': 'Pengaturan',
  'set.ticketFields': 'Kolom Tiket',
  'set.ticketForms': 'Formulir Tiket',
  'set.requestFailed': 'Permintaan gagal. Silakan coba lagi.',
  'set.refresh': 'Segarkan',
  'set.saving': 'Menyimpan…',
  'set.saveChanges': 'Simpan perubahan',
  'set.default': 'Default',
  'set.published': 'Dipublikasikan',
  'set.draft': 'Draf',
  'set.publish': 'Publikasikan',
  'set.unpublish': 'Batalkan publikasi',
  'set.deleteForm': 'Hapus formulir',
  'set.description': 'Deskripsi',
  'set.relationshipSource': 'Sumber relasi',
  'set.dependsOn': 'Bergantung pada {field}',
  'set.deleteFormTitle': 'Hapus “{name}”?',
  'set.deleteFormDescription': 'Formulir tiket ini beserta konfigurasinya akan dihapus secara permanen.',
  'set.formIdRequired': 'ID formulir wajib diisi.',
  'set.formNotFound': 'Formulir tiket tidak ditemukan.',
  'set.tf.removeOption': 'Hapus {label}',
  'set.tf.noOptions': 'Belum ada opsi yang ditentukan.',
  'set.tf.addOptionPlaceholder': 'Tambah opsi...',
  'set.tf.add': 'Tambah',
  'set.tf.dependsOnField': 'Bergantung pada kolom',
  'set.tf.selectParent': '— Pilih kolom induk —',
  'set.tf.parentHelp': 'Kolom dropdown induk yang nilai terpilihnya menentukan opsi yang tersedia untuk kolom ini.',
  'set.tf.optionMappings': 'Pemetaan opsi',
  'set.tf.savingParen': '(menyimpan...)',
  'set.tf.mappingsError': 'Tidak dapat memuat pemetaan',
  'set.tf.archivedParen': ' (diarsipkan)',
  'set.tf.mappedCount': '{count} dipetakan',
  'set.tf.saveFirst': 'Simpan kolom terlebih dahulu untuk mengonfigurasi pemetaan opsi.',
  'set.tf.newField': '{type} baru',
  'set.tf.pageDescription': 'Kelola definisi kolom yang diimpor, visibilitas, aturan wajib, dan urutan yang digunakan oleh formulir tiket.',
  'set.tf.addField': 'Tambah kolom',
  'set.tf.addFieldHelp': 'Seret jenis ke daftar kolom atau gunakan Tambah.',
  'set.tf.addType': 'Tambah {type}',
  'set.tf.registry': 'Registri kolom',
  'set.tf.savingOrder': 'Menyimpan urutan…',
  'set.tf.searchAria': 'Cari kolom tiket',
  'set.tf.searchPlaceholder': 'Cari berdasarkan nama atau kunci...',
  'set.tf.filterAria': 'Filter berdasarkan jenis kolom',
  'set.tf.allTypes': 'Semua jenis kolom',
  'set.tf.emptyFirstTitle': 'Tambahkan kolom tiket pertama Anda',
  'set.tf.emptyFirstDesc': 'Seret jenis kolom dari palet atau gunakan Tambah untuk membuatnya.',
  'set.tf.emptyFilterTitle': 'Tidak ada kolom yang cocok dengan filter ini',
  'set.tf.emptyFilterDesc': 'Coba istilah pencarian lain atau perluas filter jenis kolom.',
  'set.tf.archived': 'Diarsipkan',
  'set.tf.dependent': 'Dependen',
  'set.tf.customerVisible': 'Terlihat oleh pelanggan',
  'set.tf.internal': 'Internal',
  'set.tf.configuration': 'Konfigurasi kolom',
  'set.tf.selectTitle': 'Pilih kolom untuk dikonfigurasi',
  'set.tf.selectDesc': 'Pilih kolom dari registri untuk mengedit label, aturan, dan visibilitasnya.',
  'set.tf.externalId': 'ID eksternal: {value}',
  'set.tf.sourceRenderer': 'Sumber: {source} · Renderer: {renderer}',
  'set.tf.optionSource': 'Sumber opsi: {value}',
  'set.tf.dependsOnKey': 'Bergantung pada: {value}',
  'set.tf.internalLabel': 'Label internal',
  'set.tf.customerLabel': 'Label pelanggan',
  'set.tf.relationshipHelp': 'Menentukan dari mana nilai pencarian diambil saat runtime.',
  'set.tf.validationVisibility': 'Validasi dan visibilitas',
  'set.tf.requiredAgents': 'Wajib untuk agen',
  'set.tf.requiredCustomers': 'Wajib untuk pelanggan',
  'set.tf.requiredClosure': 'Wajib untuk penutupan',
  'set.tf.displayedCustomers': 'Ditampilkan kepada pelanggan',
  'set.tf.customersEdit': 'Pelanggan dapat mengedit',
  'set.tf.customersFilter': 'Pelanggan dapat memfilter',
  'set.tf.active': 'Aktif',
  'set.tf.dropdownOptions': 'Opsi dropdown ({count})',
  'set.tf.archiveTitle': 'Arsipkan “{name}”?',
  'set.tf.archiveDesc': 'Kolom akan menjadi tidak aktif dan tidak tersedia untuk tiket baru. Data tiket yang ada tetap dipertahankan.',
  'set.tf.archiveField': 'Arsipkan kolom',
  'set.tf.alreadyArchived': 'Sudah diarsipkan',
  'set.tf.archivedNote': 'Kolom yang diarsipkan tetap tersedia untuk nilai historis.',
  'set.tfm.systemUser': 'Sistem',
  'set.tfm.untitled': 'Formulir tanpa judul',
  'set.tfm.pageDescription': 'Buat formulir yang dapat digunakan ulang dan pilih kolom impor mana yang dapat digunakan agen dan pelanggan.',
  'set.tfm.newForm': 'Formulir baru',
  'set.tfm.creating': 'Membuat…',
  'set.tfm.allForms': 'Semua formulir',
  'set.tfm.configuredOne': '{count} formulir dikonfigurasi',
  'set.tfm.configuredMany': '{count} formulir dikonfigurasi',
  'set.tfm.filter': 'Filter',
  'set.tfm.searchAria': 'Cari formulir tiket',
  'set.tfm.searchPlaceholder': 'Cari formulir…',
  'set.tfm.status': 'Status',
  'set.tfm.allStatuses': 'Semua status',
  'set.tfm.emptyFilterTitle': 'Tidak ada formulir yang cocok dengan filter ini',
  'set.tfm.emptyFilterDesc': 'Coba istilah pencarian lain atau perluas filter status.',
  'set.tfm.emptyFirstTitle': 'Buat formulir tiket pertama Anda',
  'set.tfm.emptyFirstDesc': 'Buat formulir untuk mulai mengonfigurasi kolom impor.',
  'set.tfm.createFirst': 'Buat formulir pertama Anda',
  'set.tfm.colName': 'Nama',
  'set.tfm.colCreatedAt': 'Dibuat pada',
  'set.tfm.colUpdatedBy': 'Terakhir diperbarui oleh',
  'set.tfm.colUpdatedAt': 'Terakhir diperbarui pada',
  'set.tfm.colPortals': 'Portal terkait',
  'set.tfm.colActions': 'Tindakan',
  'set.tfm.notConfigured': 'Belum dikonfigurasi',
  'set.tfm.actionsFor': 'Tindakan untuk {name}',
  'set.tfm.editForm': 'Edit formulir',
  'set.tb.section.default.title': 'Kolom default',
  'set.tb.section.default.desc': 'Kolom alur kerja dukungan inti yang diimpor dari sistem sumber.',
  'set.tb.section.custom.title': 'Kolom kustom',
  'set.tb.section.custom.desc': 'Kolom tambahan yang dikonfigurasi untuk proses dukungan Anda.',
  'set.tb.section.nested.title': 'Kolom bersarang',
  'set.tb.section.nested.desc': 'Kolom dependen yang opsinya mengikuti kolom induk.',
  'set.tb.discardTitle': 'Buang perubahan yang belum disimpan?',
  'set.tb.discardDesc': 'Perubahan Anda pada formulir tiket ini belum disimpan.',
  'set.tb.leave': 'Keluar tanpa menyimpan',
  'set.tb.nameRequired': 'Nama formulir wajib diisi.',
  'set.tb.saved': 'Formulir disimpan.',
  'set.tb.nowPublished': 'Formulir dipublikasikan.',
  'set.tb.nowUnpublished': 'Publikasi formulir dibatalkan.',
  'set.tb.admin': 'Admin',
  'set.tb.builder': 'Pembuat',
  'set.tb.titleAria': 'Judul formulir',
  'set.tb.defaultLocked': 'Default / terkunci',
  'set.tb.previewPortal': 'Pratinjau di portal',
  'set.tb.configureTitle': 'Konfigurasikan kolom yang disertakan dalam formulir ini.',
  'set.tb.configureDesc': 'Perubahan disimpan ke basis data pusat dukungan saat Anda memilih Simpan perubahan. Kolom wajib tetap aktif.',
  'set.tb.formDetails': 'Detail formulir',
  'set.tb.formDetailsHelp': 'Gunakan deskripsi yang jelas agar administrator tahu kapan formulir ini digunakan.',
  'set.tb.descPlaceholder': 'Jelaskan kapan formulir ini harus digunakan…',
  'set.tb.importedFields': 'Kolom impor',
  'set.tb.importedHelp': 'Seret untuk mengubah urutan kolom. Gunakan sakelar untuk menyertakan atau mengecualikan kolom dari formulir ini.',
  'set.tb.noneInSection': 'Tidak ada kolom impor di bagian ini.',
  'set.tb.dragReorder': 'Seret untuk mengubah urutan',
  'set.tb.required': 'Wajib',
  'set.tb.nested': 'Bersarang',
  'set.tb.enableField': 'Aktifkan {label}',
  'set.tb.enabled': 'Diaktifkan',
  'set.tb.disabled': 'Dinonaktifkan',
  'set.tb.emptyTitle': 'Belum ada kolom untuk dikonfigurasi',
  'set.tb.emptyDesc': 'Impor kolom tiket untuk mulai membuat formulir ini.',
  'set.tb.deleting': 'Menghapus…',
  'set.tp.loadError': 'Tidak dapat memuat pratinjau formulir.',
  'set.tp.preview': 'Pratinjau',
  'set.tp.customerPreview': 'Pratinjau tampilan pelanggan',
  'set.tp.backToBuilder': 'Kembali ke pembuat',
  'set.tp.modeTitle': 'Mode pratinjau',
  'set.tp.modeDesc': 'Ini adalah pratinjau tanpa pengiriman. Semua kolom yang diaktifkan ditampilkan sesuai urutan formulir yang tersimpan.',
  'set.tp.emptyTitle': 'Belum ada kolom yang diaktifkan',
  'set.tp.emptyDesc': 'Aktifkan kolom di pembuat formulir untuk melihatnya di pratinjau ini.',

  'por.error.generic': 'Tidak dapat menyelesaikan permintaan.',
  'por.error.requestNotFound': 'Permintaan tidak ditemukan.',
  'por.error.formUnavailable': 'Formulir permintaan tidak tersedia.',
  'por.error.articleNotFound': 'Artikel tidak ditemukan.',
  'por.error.selectRating': 'Silakan pilih peringkat dari 1 sampai 5.',
  'por.tab.all': 'Semua',
  'por.list.title': 'Permintaan dukungan saya',
  'por.list.description': 'Pantau permintaan Anda dan balas tim dukungan.',
  'por.list.newRequest': 'Permintaan baru',
  'por.list.knowledgeBase': 'Basis pengetahuan',
  'por.list.filterByStatus': 'Filter permintaan berdasarkan status',
  'por.list.searchPlaceholder': 'Cari berdasarkan subjek…',
  'por.list.count': '{count} permintaan',
  'por.list.countOne': '{count} permintaan',
  'por.list.emptyFilteredTitle': 'Tidak ada permintaan yang cocok dengan tampilan ini',
  'por.list.emptyTitle': 'Belum ada permintaan',
  'por.list.emptyFilteredDescription': 'Coba tab Semua atau istilah pencarian lain.',
  'por.list.emptyDescription': 'Kirim permintaan dan tim dukungan akan menanganinya.',
  'por.list.submitFirst': 'Kirim permintaan pertama Anda',
  'por.col.request': 'Permintaan',
  'por.col.subject': 'Subjek',
  'por.col.status': 'Status',
  'por.col.priority': 'Prioritas',
  'por.col.created': 'Dibuat',
  'por.detail.myRequests': 'Permintaan saya',
  'por.detail.reopen': 'Buka kembali permintaan ini',
  'por.detail.attachments': 'Lampiran',
  'por.detail.download': 'Unduh',
  'por.detail.conversation': 'Percakapan',
  'por.detail.noReplies': 'Belum ada balasan',
  'por.detail.noRepliesHint': 'Tambahkan balasan di bawah dan tim dukungan akan menanganinya.',
  'por.detail.reply': 'Balas',
  'por.detail.replyPlaceholder': 'Tulis balasan',
  'por.detail.sending': 'Mengirim…',
  'por.detail.sendReply': 'Kirim balasan',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Hapus {name}',
  'por.submit.newRequest': 'Permintaan baru',
  'por.submit.defaultTitle': 'Kirim permintaan dukungan',
  'por.submit.intro': 'Lengkapi kolom di bawah ini lalu kirim permintaan Anda.',
  'por.submit.subjectRequired': 'Subjek wajib diisi',
  'por.submit.descriptionRequired': 'Deskripsi wajib diisi',
  'por.submit.attachments': 'Lampiran',
  'por.submit.submitting': 'Mengirim…',
  'por.submit.submit': 'Kirim permintaan',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Basis pengetahuan',
  'por.kb.description': 'Temukan jawaban sebelum mengirim permintaan.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Hasil pencarian',
  'por.kb.searchPlaceholder': 'Cari artikel',
  'por.kb.emptyTitle': 'Belum ada artikel yang dipublikasikan',
  'por.kb.emptyDescription': 'Kirim permintaan dan tim dukungan akan membantu Anda secara langsung.',
  'por.kb.noFolders': 'Tidak ada folder',
  'por.kb.articles': '{count} artikel',
  'por.kb.articlesOne': '{count} artikel',
  'por.kb.noMatch': 'Tidak ada artikel yang cocok dengan “{query}”',
  'por.kb.folderEmpty': 'Belum ada artikel di folder ini',
  'por.kb.noMatchHint': 'Coba istilah pencarian yang lebih singkat, atau kirim permintaan.',
  'por.kb.folderEmptyHint': 'Jelajahi folder lain, atau kirim permintaan.',
  'por.kb.submitRequest': 'Kirim permintaan',
  'por.kb.views': '{count} tayangan',
  'por.kb.thanks': 'Terima kasih atas masukan Anda!',
  'por.kb.helpful': 'Apakah ini membantu?',
  'por.kb.yes': 'Ya',
  'por.kb.no': 'Tidak',
  'por.csat.thanksTitle': 'Terima kasih atas masukan Anda',
  'por.csat.thanksBody': 'Tanggapan Anda telah dicatat.',
  'por.csat.title': 'Bagaimana layanan kami?',
  'por.csat.request': 'Permintaan #{number}: {subject}',
  'por.csat.rating': 'Peringkat',
  'por.csat.stars': '{count} bintang',
  'por.csat.comment': 'Komentar',
  'por.csat.submit': 'Kirim masukan',
  'agents.tempPassword.title': 'Kata sandi sementara',
  'agents.tempPassword.help': 'Atur kata sandi sementara untuk agen ini. Agen akan diminta membuat kata sandi baru saat masuk berikutnya. Minimal 12 karakter.',
  'agents.tempPassword.button': 'Atur kata sandi sementara',
  'agents.tempPassword.saving': 'Mengatur…',
  'agents.tempPassword.error': 'Tidak dapat mengatur kata sandi sementara.',
  'ui.showPassword': 'Tampilkan kata sandi',
  'ui.hidePassword': 'Sembunyikan kata sandi',
  'dashboard.awaitingResolutionConfirmation': 'Menunggu konfirmasi penyelesaian',
  'dashboard.awaitingUserReply': 'Menunggu balasan pengguna',
  'dashboard.changeRequests': 'Permintaan perubahan',
  'agents.tempPassword.successEmailed': 'Kata sandi sementara diatur dan dikirim ke agen melalui email.',
  'agents.tempPassword.successNotEmailed': 'Kata sandi sementara diatur, tetapi email tidak dapat dikirim. Bagikan kata sandi kepada agen melalui saluran yang aman.',
} as const;

export default id;
